function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import lodashSet from 'lodash/set';
import { LOAD_CHILDREN_OPTIONS, Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ElSelectTree from 'el-select-tree';
import currencyInput from '@/components/v-currencyInput/CurrencyInput'; // import inputDbl from '@/components/v-input-dblclick/inputDblclick'

import { getCon, getContinentList, getChildCountry, getCountryCodeByCity, getCityCodeName, getUnderCountry, getUnderCity, getProvinceCity } from '@/utils/country';
import List_obj from './list_obj.js';
import { isNumber } from '@/utils/util';
import { findByNo, findProtoBaseInfo, submitProtoInfo as _submitProtoInfo } from '@/api/protocol';
import { getBaseDateInfo, getBaseDateList, getCompanyList, getProductList as _getProductList, getClauseList, getQueryByCodeType, getEngageList, getLimitList, getAgencyLisy, continentList, getKindInfoList, getAllContinent, getClauseListByType as _getClauseListByType, getItemList, queryAllContinent, getDefinedList as _getDefinedList, getProvinceCityArea } from '@/api/baseDate';
import { customRegion_queryAll, getSelfItemList } from '@/api/baseDataManage';
export default {
  name: 'ProtocolInsert',
  components: {
    Treeselect: Treeselect,
    ElSelectTree: ElSelectTree,
    currencyInput: currencyInput
  },
  props: ['comingtype', 'comingprotocolNo', 'isReview'],
  data: function data() {
    var _ref;

    return _ref = {
      componentList: [],
      areaListArr: [],
      expands: [],
      areaProps: {
        // 省市区三级联动
        label: 'codeCname',
        value: 'codeCode'
      },
      provinceList: [],
      getRowKeys: function getRowKeys(row) {
        return row.serialNo;
      },
      attAgencyList: [],
      salesmanList: [],
      businessList: [],
      intermediaryList: [],
      coInsurerList: [],
      managerList: [],
      paramsData: {
        insuranceCompanyCode: '',
        userName: '',
        userCode: ''
      },
      lowFeeData: '',
      // 最低保费币种
      isFlag: false,
      treeProps: {
        value: 'codeCode',
        children: 'children',
        label: 'codeCname'
      },
      clearable: true,
      isRequired: false,
      defaultExpandAll: false,
      multiple: false,
      placeholder: 'please choose',
      disabled: false,
      checkStrictly: false,
      defaultProps: {
        multiple: true,
        checkStrictly: false,
        children: 'children',
        label: 'codeCname',
        value: 'codeCode'
      },
      options: [],
      sortValueBy: 'LEVEL',
      protoInsertForm: {},
      operationType: '',
      // 操作类型
      activeName: 'first',
      oldActiveName: '',
      dialogStatus: '',
      dialogFormVisible: false,
      insuredStyle: 'box-card',
      protoMageForm: {
        protocolMainDto: {},
        // 协议基本信息
        protocolApplicantDto: {},
        // 投保人信息
        protocolCoinsDto: {} // 联共保基础信息

      },
      protocolRiskDto: {
        protocolNo: '',
        serialNo: '',
        riskName: '',
        riskCode: '',
        insuranCecompanyCode: '',
        insuranCecompanyName: '',
        conveYanceWayList: [],
        conveYanceWay: '',
        currencyList: [],
        currency: '',
        lowCurrency: '',
        // 最低保费币种
        optionalPack: '',
        optionalPackList: [],
        insureUpperLimit: '',
        insureDefault: '110',
        isOpen: '0',
        // 自定义是否到客户层级 1是 0否
        documentType: '',
        shipClassList: [],
        shipClass: '',
        shipType: '',
        shipAge: '',
        shipAgeEnd: '',
        termsOfTrade: [],
        isAutoDeclare: '0',
        isAgreementBalance: '0',
        isAloneBalance: '0',
        allowReverseTime: '',
        rejectCargoTypeList: [],
        rejectCargoType: '',
        rejectCargoNameList: [],
        rejectCargoName: '',
        rejectCargoList: [],
        rejectCargo: '',
        isEnameRequired: '0'
      },
      riskConveyintervalDto: {
        protocolNo: '',
        serialNo: '',
        insuranCecompanyCode: '',
        insuranCecompanyName: '',
        clauseType: '',
        clauseName: '',
        clauseCode: '',
        riskName: '',
        riskCode: '',
        kindCode: '',
        kindName: '',
        coStartContinentCodeList: [],
        coStartContinentCode: '',
        coStartCountryCodeList: [],
        coStartCountryCode: '',
        coStartCityCodeList: [],
        coStartCityCode: '',
        exStartContinentCodeList: [],
        exStartContinentCode: '',
        exStartCountryCodeList: [],
        exStartCountryCode: '',
        exStartCityCodeList: [],
        exStartCityCode: '',
        coViaContinentCodeList: [],
        coViaContinentCode: '',
        coViaCountryCodeList: [],
        coViaCountryCode: '',
        coViaCityCodeList: [],
        coViaCityCode: '',
        exViaContinentCodeList: [],
        exViaContinentCode: '',
        exViaCountryCodeList: [],
        exViaCountryCode: '',
        exViaCityCodeList: [],
        exViaCityCode: '',
        coEndContinentCodeList: [],
        coEndContinentCode: '',
        coEndCountryCodeList: [],
        coEndCountryCode: '',
        coEndCityCodeList: [],
        coEndCityCode: '',
        exEndContinentCodeList: [],
        exEndContinentCode: '',
        exEndCountryCodeList: [],
        exEndCountryCode: '',
        exEndCityCodeList: [],
        exEndCityCode: '',
        validationFlag: '',
        flag: ''
      },
      // 洲-国家-城市
      protocolConveyintervalDto: {
        protocolNo: '',
        serialNo: '',
        insuranCecompanyCode: '',
        insuranCecompanyName: '',
        clauseType: '',
        clauseName: '',
        clauseCode: '',
        riskName: '',
        riskCode: '',
        kindCode: '',
        kindName: '',
        coStartContinentCodeList: [],
        coStartContinentCode: '',
        coStartCountryCodeList: [],
        coStartCountryCode: '',
        coStartCityCodeList: [],
        coStartCityCode: '',
        exStartContinentCodeList: [],
        exStartContinentCode: '',
        exStartCountryCodeList: [],
        exStartCountryCode: '',
        exStartCityCodeList: [],
        exStartCityCode: '',
        coViaContinentCodeList: [],
        coViaContinentCode: '',
        coViaCountryCodeList: [],
        coViaCountryCode: '',
        coViaCityCodeList: [],
        coViaCityCode: '',
        exViaContinentCodeList: [],
        exViaContinentCode: '',
        exViaCountryCodeList: [],
        exViaCountryCode: '',
        exViaCityCodeList: [],
        exViaCityCode: '',
        coEndContinentCodeList: [],
        coEndContinentCode: '',
        coEndCountryCodeList: [],
        coEndCountryCode: '',
        coEndCityCodeList: [],
        coEndCityCode: '',
        exEndContinentCodeList: [],
        exEndContinentCode: '',
        exEndCountryCodeList: [],
        exEndCountryCode: '',
        exEndCityCodeList: [],
        exEndCityCode: '',
        validationFlag: '',
        flag: ''
      },
      // 条款洲-国家-城市
      protocolConveyintervalDto2: {
        protocolNo: '',
        serialNo: '',
        insuranCecompanyCode: '',
        insuranCecompanyName: '',
        clauseType: '',
        clauseName: '',
        clauseCode: '',
        riskName: '',
        riskCode: '',
        kindCode: '',
        kindName: '',
        coStartContinentCodeList: [],
        coStartContinentCode: '',
        coStartCountryCodeList: [],
        coStartCountryCode: '',
        coStartCityCodeList: [],
        coStartCityCode: '',
        exStartContinentCodeList: [],
        exStartContinentCode: '',
        exStartCountryCodeList: [],
        exStartCountryCode: '',
        exStartCityCodeList: [],
        exStartCityCode: '',
        coViaContinentCodeList: [],
        coViaContinentCode: '',
        coViaCountryCodeList: [],
        coViaCountryCode: '',
        coViaCityCodeList: [],
        coViaCityCode: '',
        exViaContinentCodeList: [],
        exViaContinentCode: '',
        exViaCountryCodeList: [],
        exViaCountryCode: '',
        exViaCityCodeList: [],
        exViaCityCode: '',
        coEndContinentCodeList: [],
        coEndContinentCode: '',
        coEndCountryCodeList: [],
        coEndCountryCode: '',
        coEndCityCodeList: [],
        coEndCityCode: '',
        exEndContinentCodeList: [],
        exEndContinentCode: '',
        exEndCountryCodeList: [],
        exEndCountryCode: '',
        exEndCityCodeList: [],
        exEndCityCode: '',
        validationFlag: '',
        flag: ''
      },
      // 条款洲-国家-城市
      protocolConveyintervalDto3: {
        // 条款洲-国家-城市  保额保费限制条件 运输区间
        coStartCityCodeList: [],
        exStartCityCodeList: [],
        coViaCityCodeList: [],
        exViaCityCodeList: [],
        coEndCityCodeList: [],
        exEndCityCodeList: []
      },
      viewDisable: false,
      // 协议查看详情列表
      riskView: false,
      // 产品查看
      clauseView: false,
      // 条则查看
      editRiskState: false,
      // 产品修改信息
      tableShow: false,
      protoInfo: false,
      insureDisable: true,
      activeInfoName: 'first',
      clauseInfoType: false,
      // 条款详情隐藏
      transSection: false,
      // 运输区间是否显隐
      protocolSection: false,
      //运输区间 特别因子
      containerState: false,
      // 集装箱显隐
      packingstate: false,
      // 包装显隐
      transModeState: false,
      // 运输方式显隐
      reportState: false,
      // 申报基准显隐1
      triggerReportState: false,
      // 申报基准显隐2
      theInsuredState: false,
      //被保险人显隐
      theInsuredState2: false,
      //被保险人显隐2
      theInsuredState3: false,
      //被保险人显隐3
      markupState: false,
      // 特殊加成比例字段
      triggerItemState: false,
      // 标的类型显隐
      triggerTransModeState: false,
      // 运输方式显隐
      triggerRefrigerateState: false,
      // 是否冷藏显隐
      packState: false,
      // 是否包装
      premiumType: false,
      // 保额保费限制条件
      itemPremium: false,
      // 保额保费限制条件- 标的
      transPremium: false,
      // 保额保费限制条件 -运输方式
      transSectionBEBF: false,
      // 保额保费限制条件 -运输区间
      engageType: false,
      // 特约弹框状态
      conveyPremium: false,
      // 特约状态运输方式状态、、、、、
      itemCodePremium: false,
      // 特约状态标的状态、、、、、
      protocoPremiumState: false,
      // 保额保费状态码
      protocolEngageState: false,
      // 特约状态码
      loading: false,
      // 遮罩
      trueOrFalse: List_obj.trueOrFalse,
      // 是否判断
      mineStatus: '',
      decimalValue: 2,
      mineStatusValue: [],
      inSureTypeList: List_obj.inSureTypeList,
      clauseAttributeList: List_obj.clauseAttributeList,
      protocolInsuredDtoList: [],
      // 被保险人清单
      // 联共保集合
      protocolCoinsDtoList: [],
      // 联共保集合
      tansportInfoList: [],
      // 运输区间集合
      protocolAmountDtoList: [],
      // 保额保费集合
      protocolClauseDtoList: [],
      // 条款集合
      protocolLimitDtoList: [],
      // 全单限额免赔
      clauseInfo: {},
      // 条款对象
      protocolClauseDto: {},
      // 条则对象
      protocolClausefactorDto: {},
      // 条款责任费率配置
      protocolAddrisksfactorDto: {},
      // 条件触发附加险规则
      protocolAmountDto: {},
      // 保额保费限制对象
      protocolEngageDto: {
        state: '',
        influenceTypeList: []
      },
      // 特约内容对象
      protocolEngageDtoList: []
    }, _defineProperty(_ref, "protocolAddrisksfactorDto", {
      selectCondFlagList: [],
      itemTypeList: [],
      conveYanceWayList: [],
      packgeList: [] // 包装

    }), _defineProperty(_ref, "premiumInfo", {
      conveyance: []
    }), _defineProperty(_ref, "protocolShipageDtoList", []), _defineProperty(_ref, "protocolKeepGrainDtoList", []), _defineProperty(_ref, "protocolRiskDtoList", []), _defineProperty(_ref, "limitOptions", []), _defineProperty(_ref, "pagination", {
      currentPage: 1,
      // 当前页
      pageNumber: 1,
      pageSize: 5,
      // 展示条数
      pageSizes: [5, 10, 20],
      // 展示条数列表
      totalItems: 0 // 总条数

    }), _defineProperty(_ref, "engageList", []), _defineProperty(_ref, "value", ''), _defineProperty(_ref, "packgeList", []), _defineProperty(_ref, "addFormVisible", false), _defineProperty(_ref, "bcItemList", []), _defineProperty(_ref, "itemChildList", []), _defineProperty(_ref, "defineList", []), _defineProperty(_ref, "isCompanyItemList", []), _defineProperty(_ref, "companyList", []), _defineProperty(_ref, "currencyList", []), _defineProperty(_ref, "settleList", []), _defineProperty(_ref, "idCardList", []), _defineProperty(_ref, "sourceList", []), _defineProperty(_ref, "businessList", []), _defineProperty(_ref, "coinsFlagList", []), _defineProperty(_ref, "coinpayTypeList", []), _defineProperty(_ref, "clauseList", []), _defineProperty(_ref, "kindList", []), _defineProperty(_ref, "conveyanceList", []), _defineProperty(_ref, "packTypeLitst", []), _defineProperty(_ref, "shipClassInfoList", []), _defineProperty(_ref, "emailReceiverInfoList", [{
      codeCode: '1',
      codeCname: '投保人'
    }, {
      codeCode: '2',
      codeCname: '被保险人'
    }, {
      codeCode: '3',
      codeCname: '中介'
    }, {
      codeCode: '4',
      codeCname: '内部推送邮箱'
    }]), _defineProperty(_ref, "shipTypeList", []), _defineProperty(_ref, "productList", []), _defineProperty(_ref, "tradeTermsList", []), _defineProperty(_ref, "theInsuredList", []), _defineProperty(_ref, "theInsuredList2", []), _defineProperty(_ref, "theInsuredList3", []), _defineProperty(_ref, "itemInfoList", []), _defineProperty(_ref, "continentList", []), _defineProperty(_ref, "countryList", []), _defineProperty(_ref, "cityList", []), _defineProperty(_ref, "baseCoCountryList", []), _defineProperty(_ref, "baseCoCityList", []), _defineProperty(_ref, "baseExCountryList", []), _defineProperty(_ref, "baseExCityList", []), _defineProperty(_ref, "baseCoViaCountryList", []), _defineProperty(_ref, "baseCoViaCityList", []), _defineProperty(_ref, "baseExViaCountryList", []), _defineProperty(_ref, "baseExViaCityList", []), _defineProperty(_ref, "baseCoEndCountryList", []), _defineProperty(_ref, "baseCoEndCityList", []), _defineProperty(_ref, "baseExEndCountryList", []), _defineProperty(_ref, "baseExEndCityList", []), _defineProperty(_ref, "continentInfoList", []), _defineProperty(_ref, "clauseCoCountryList", []), _defineProperty(_ref, "clauseCoCityList", []), _defineProperty(_ref, "clauseExCountryList", []), _defineProperty(_ref, "clauseExCityList", []), _defineProperty(_ref, "clauseCoViaCountryList", []), _defineProperty(_ref, "clauseCoViaCityList", []), _defineProperty(_ref, "clauseExViaCountryList", []), _defineProperty(_ref, "clauseExViaCityList", []), _defineProperty(_ref, "clauseCoEndCountryList", []), _defineProperty(_ref, "clauseCoEndCityList", []), _defineProperty(_ref, "clauseExEndCountryList", []), _defineProperty(_ref, "clauseExEndCityList", []), _defineProperty(_ref, "mineStatusValue", []), _defineProperty(_ref, "newOrOldStates", []), _ref;
  },
  watch: {
    comingprotocolNo: function comingprotocolNo(newValue, oldValue) {
      this.comingprotocolNo = newValue;
      this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    var _this = this;

    // 基础数据加载
    // 获取保险公司集合
    getCompanyList().then(function (res) {
      _this.companyList = res;
    });
    this.continentList = getCon(); // 切换为洲-国家数据

    getCon().forEach(function (ite) {
      var children = getChildCountry(ite.codeCode);
      var cons = {
        'id': ite.codeCode,
        'label': ite.codeCname,
        'level': '1',
        'children': children
      };

      _this.options.push(cons);
    }); // this.continentList = JSON.parse(sessionStorage.getItem("continent"))
    // this.continentInfoList = getContinentList()
    // if (this.continentInfoList.length === 0) {
    //   const country = {
    //     'codeLever': 1,
    //     'codeCode': ['01', '02', '03', '04', '05', '06', '07']
    //   }
    //   queryAllContinent(country).then(res => {
    //     this.continentInfoList = res
    //   })
    // }
    // getAllContinent().then(res => {
    //   res.forEach(item => {
    //     if (item.codeType == 'continent') {
    //       this.continentList = item.dictionary // 洲
    //     } else if (item.codeType == 'country') {
    //       this.countryList = item.dictionary // 国家
    //     } else if (item.codeType == 'city') {
    //       this.cityList = item.dictionary // 城市
    //     }
    //   })
    // })
    // const itemInfo = {
    //   codeLever: '2',
    //   codeType: 'itemTypeParent'
    // }
    // getItemList(itemInfo).then(res => {
    //   if (res.codeType === 'itemTypeParent') {
    //     this.itemInfoList = res.dictionary //
    //   }
    // })
    //2.查找该保险公司配置的标的货物码值

    var selfMark = {
      insuranceCompanyCode: JSON.parse(sessionStorage.getItem('newinsurancecompanyCode')),
      //保险公司代码
      isCompanyLevel: '1' //是否到保险公司层级

    };
    getSelfItemList(selfMark).then(function (res) {
      _this.isCompanyItemList = res; // 自定义标的数组:自定义公司层级标的；

      console.log('标的类型的下拉列表isCompanyItemList：', _this.isCompanyItemList);

      if (_this.isCompanyItemList != null && _this.isCompanyItemList.length > 0) {
        _this.itemChildList = []; //this.itemChildList = this.isCompanyItemList // 标的子类型:自定义是否到客户层级，当为否时，查找上一层级是否设置，如果设置，则显示此层级，如果未设置，继续查找上一层级
        // this.itemChildList = [this.isCompanyItemList.length]

        for (var k = 0; k < _this.isCompanyItemList.length; k++) {
          var onei = {};
          onei.codeCode = _this.isCompanyItemList[k].itemCode;
          onei.codeCname = _this.isCompanyItemList[k].itemName;

          _this.itemChildList.push(onei);
        } // this.isCompanyItemList.forEach(function (itcnty) {
        //   const cntysds ={'codeCode':itcnty.itemCode,'codeCname':itcnty.itemName}
        //   this.itemChildList.push(cntysds);
        // });

      } else {
        //1.标的查找平台标准码值
        var itemChildInfo = {
          codeLever: '1',
          codeType: 'itemType'
        };
        getItemList(itemChildInfo).then(function (res) {
          if (res.codeType === 'itemType') {
            _this.bcItemList = res.dictionary; //平台层级标的码值

            console.log('标的类型的下拉列表bcItemList：', _this.bcItemList);
            _this.itemChildList = _this.bcItemList;
          }
        });
      }
    }); //获取归属机构

    getAgencyLisy().then(function (res) {
      _this.attAgencyList = res;
    });
    var Info = {
      codeLever: '1',
      codeType: ['currency', 'settleFlag', 'idCard', 'coinsFlag', 'coinpayType', 'conveyance', 'packType', 'tradeTerms', 'business', 'source', 'isneworold', 'shipClass', 'shipTypes', "unitNature", "nationalFlag"]
    }; // 业务归属渠道

    getQueryByCodeType({
      "codeType": "businessChannel"
    }).then(function (res) {
      // this.attAgencyList = res
      console.log(res, '获取归属机构');
      _this.businessList = res;
    }); // 结算标志

    getQueryByCodeType({
      "codeType": "settleFlag"
    }).then(function (res) {
      _this.settleList = res;
    }); // 业务来源

    /*getQueryByCodeType({"codeType": "businessType"}).then(res => {
      this.sourceList = res
    })*/
    // 获取共保人信息

    getQueryByCodeType({
      "codeType": "coins"
    }).then(function (res) {
      _this.coInsurerList = res;
    });
    /*at 2021-03-19 最新业务来源从t_bc_code里面取，结算标志、业务归属渠道从t_bc_insurancecode基础配置页面取
    --业务来源
    select * from t_bc_code where CODETYPE='source';
    --结算标志
    select * from t_bc_insurancecode where CODETYPE='settleFlag';
    --业务归属渠道
    select * from t_bc_insurancecode where CODETYPE='businessChannel';*/

    this.getAreaList();
    getBaseDateList(Info).then(function (res) {
      res.forEach(function (item) {
        if (item.codeType === 'currency') {
          _this.currencyList = item.dictionary; // 币别
        } else if (item.codeType === 'settleFlag') {//this.settleList = item.dictionary // 结算标志
        } else if (item.codeType === 'idCard') {
          _this.idCardList = item.dictionary; // 证件类型
        } else if (item.codeType === 'coinsFlag') {
          _this.coinsFlagList = item.dictionary; // 联共保标志
        } else if (item.codeType === 'coinpayType') {
          _this.coinpayTypeList = item.dictionary; // 保单缴费类型
        } else if (item.codeType === 'conveyance') {
          _this.conveyanceList = item.dictionary; // 运输工具
        } else if (item.codeType === 'packType') {
          _this.packTypeLitst = item.dictionary; // 包装
        } else if (item.codeType === 'shipClass') {
          _this.shipClassInfoList = item.dictionary; // 船级社
        } else if (item.codeType === 'shipTypes') {
          _this.shipTypeList = item.dictionary; // 船舶类型
        } else if (item.codeType === 'tradeTerms') {
          _this.tradeTermsList = item.dictionary; // 贸易条件
        } else if (item.codeType === 'business') {//this.businessList = item.dictionary // 业务归属渠道
        } else if (item.codeType === 'source') {
          _this.sourceList = item.dictionary; // 业务来源
        } else if (item.codeType === 'isneworold') {
          // 新旧标识
          _this.newOrOldStates = item.dictionary;
        } else if (item.codeType === 'unitNature') {
          _this.componentList = item.dictionary; // 单位性质
        } else if (item.codeType === 'nationalFlag') {
          _this.innerList = item.dictionary; // 境内外标识
        }
      });
    });
  },
  methods: {
    setApplicationPhone: function setApplicationPhone(tel) {
      //投保人电话 脱敏
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 5) + "****" + tel.substring(9);
        return str;
      } else {
        var phone = this.protoMageForm.protocolApplicantDto.phone; //获取到投保人的电话信息

        phone = "" + phone;
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        var phone = phone.replace(reg, "$1****$2");
        this.protoMageForm.protocolApplicantDto.phone = phone;
        return phone;
      }
    },
    setListPhone: function setListPhone(tel) {
      //被保人电话 脱敏
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 5) + "****" + tel.substring(9);
        return str;
      } else {
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        var phone = tel.replace(reg, "$1****$2");
        return phone;
      }
    },
    setApplicationAddress: function setApplicationAddress(tel) {
      // 投保人 地址
      tel = " " + tel;
      var str = " ";
      str = tel.slice(0, 0) + "********";
      return str;
    },
    setListAddress: function setListAddress(tel) {
      //被保人 地址
      tel = " " + tel;
      var str = " ";
      str = tel.slice(0, 0) + "********";
      return str;
    },
    setApplicationEmail: function setApplicationEmail(email) {
      //投保人 邮箱
      //2022-01-11 判断如果邮箱是多个的话需要特殊处理
      var emailArr = [];

      if (email.search(",") != -1) {
        emailArr = email.split(",");
        var new_email = '';

        for (var j = 0; j < emailArr.length; j++) {
          if (String(emailArr[j]).indexOf('@') > 0) {
            var str = emailArr[j].split('@');
            var _s = '';

            if (str[0].length > 3) {
              //@前面多于3位
              for (var i = 3; i < str[0].length; i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 3) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 3) + _s + '@' + str[1];
              }
            } else {
              //@前面小于等于于3位
              for (var _i = 1; _i < str[0].length; _i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 1) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 1) + _s + '@' + str[1];
              }
            }
          }
        }

        return new_email;
      } else {
        var _new_email = email;

        if (String(email).indexOf('@') > 0) {
          var _str = email.split('@');

          var _s2 = '';

          if (_str[0].length > 3) {
            //@前面多于3位
            for (var _i2 = 3; _i2 < _str[0].length; _i2++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 3) + _s2 + '@' + _str[1];
          } else {
            //@前面小于等于于3位
            for (var _i3 = 1; _i3 < _str[0].length; _i3++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 1) + _s2 + '@' + _str[1];
          }
        }

        return _new_email;
      }
    },
    selectUnit: function selectUnit(value) {
      var _this2 = this;

      // 单位性质
      this.componentList.forEach(function (item) {
        if (item.codeCode === value) {
          _this2.protoMageForm.protocolApplicantDto.unitNatureName = item.codeCname;
        }
      });
    },
    selectInner: function selectInner(value) {
      var _this3 = this;

      //境内外标识
      this.innerList.forEach(function (item) {
        if (item.codeCode === value) {
          _this3.protoMageForm.protocolApplicantDto.nationalFlagName = item.codeCname;
        }
      });
    },
    // 获取省市区
    getAreaList: function getAreaList() {
      var _this4 = this;

      getProvinceCityArea({}).then(function (res) {
        _this4.areaListArr = res;
      });
    },
    // 选择省市区
    handleChange: function handleChange(value) {
      var _this5 = this;

      this.protoMageForm.protocolApplicantDto.provinceCode = value[0];
      this.protoMageForm.protocolApplicantDto.cityCode = value[1];
      this.protoMageForm.protocolApplicantDto.areaCode = value[2];
      this.areaListArr.forEach(function (item) {
        if (item.codeCode === value[0]) {
          _this5.protoMageForm.protocolApplicantDto.provinceName = item.codeCname;
          item.children.forEach(function (semp) {
            if (semp.codeCode === value[1]) {
              _this5.protoMageForm.protocolApplicantDto.cityName = semp.codeCname;
            }

            semp.children.forEach(function (temp) {
              if (temp.codeCode === value[2]) {
                _this5.protoMageForm.protocolApplicantDto.areaName = temp.codeCname;
              }
            });
          });
        }
      });
    },
    // 选择省市区
    handleChanges: function handleChanges(value, indexInfo) {
      var _this6 = this;

      this.protocolInsuredDtoList.forEach(function (item) {
        _this6.protocolInsuredDtoList[indexInfo].provinceCode = value[0];
        _this6.protocolInsuredDtoList[indexInfo].cityCode = value[1];
        _this6.protocolInsuredDtoList[indexInfo].areaCode = value[2];
      });
      this.areaListArr.forEach(function (item) {
        if (item.codeCode === value[0]) {
          _this6.protocolInsuredDtoList[indexInfo].provinceName = item.codeCname;
          item.children.forEach(function (semp) {
            if (semp.codeCode === value[1]) {
              _this6.protocolInsuredDtoList[indexInfo].cityName = semp.codeCname;
            }

            semp.children.forEach(function (temp) {
              if (temp.codeCode === value[2]) {
                _this6.protocolInsuredDtoList[indexInfo].areaName = temp.codeCname;
              }
            });
          });
        }
      });
    },
    // 是否开启
    isOpenSelection: function isOpenSelection(val) {
      console.log('val', val);

      if (val === '1') {
        this.protocolRiskDto.rejectCargoList = [];
        this.protocolRiskDto.rejectCargo = '';
        this.$forceUpdate();
        console.log('list1', this.protocolRiskDto.rejectCargoList);
      } else {
        this.protocolRiskDto.rejectCargoList = [];
        this.protocolRiskDto.rejectCargo = '';
        this.$forceUpdate();
      }
    },
    // 获取自定义表的类型
    getDefinedList: function getDefinedList() {
      var _this7 = this;

      _getDefinedList(this.paramsData).then(function (res) {
        _this7.defineList = res;
        console.log('自定义标的数组赋值', _this7.defineList);
      });
    },
    dataDefinedList: function dataDefinedList() {
      var _this8 = this;

      //3.查找该保险公司配置的标的货物码值
      var selfMark = {
        userCode: this.protoMageForm.protocolApplicantDto.identifyNumber,
        insuranceCompanyCode: JSON.parse(sessionStorage.getItem('newinsurancecompanyCode')),
        //保险公司代码
        isCompanyLevel: '0' //是否到保险公司层级

      };
      getSelfItemList(selfMark).then(function (res) {
        _this8.defineList = res; // 自定义标的数组:自定义客户层级标的；

        console.log('标的类型的下拉列表 defineList：', _this8.defineList);
      });
    },
    // 限额币种展示
    codeCoins: function codeCoins(codeCode) {
      var codevalue;
      this.currencyList.forEach(function (item) {
        if (item.codeCode == codeCode) {
          codevalue = item.codeValue;
          return;
        }
      });
      return codevalue;
    },
    //YCKK-1140 协议修改和查询时，下拉框如找不到则直接从协议主表中添加，页面不能显示为空
    //查看和修改页面--加工下拉框的值--在原本的下拉框基础上，判断是否包含协议查看和修改的值，不包含就在下拉框里加上协议保存的值
    convertOptionList: function convertOptionList(code, staus, label) {
      console.log(code, '下拉框要展示的code');
      console.log(staus, '下拉框类型：1中介机构、2中介经办人、3业务员、4共保人名称、5业务归属渠道');
      console.log(label, '下拉框要展示的name');

      if (staus && code) {
        //入参staus不能为空
        if (staus == '1') {
          //1中介机构
          console.log(this.intermediaryList, '1中介机构');
          var codeFlag = 0; //判断this.intermediaryList 是否包含code，不包含的话添加code-label

          if (this.intermediaryList) {
            this.intermediaryList.forEach(function (ele) {
              if (ele.intermediaryOrganCode == code) {
                codeFlag = 1;
              }
            });
          } else {
            this.intermediaryList = [];
          }

          if (codeFlag == 0) {
            this.intermediaryList.push({
              intermediaryOrganCode: code,
              intermediaryOrganName: label
            });
          }
        } else if (staus == '2') {
          console.log(this.managerList, '2中介经办人');
          var codeFlag = 0;

          if (this.managerList) {
            this.managerList.forEach(function (ele) {
              if (ele.agentManCode == code) {
                codeFlag = 1;
              }
            });
          } else {
            this.managerList = [];
          }

          if (codeFlag == 0) {
            this.managerList.push({
              agentManCode: code,
              agentManName: label
            });
          }
        } else if (staus == '3') {
          console.log(this.salesmanList, '3业务员');
          var codeFlag = 0;

          if (this.salesmanList) {
            this.salesmanList.forEach(function (ele) {
              if (ele.salesCode == code) {
                codeFlag = 1;
              }
            });
          } else {
            this.salesmanList = [];
          }

          if (codeFlag == 0) {
            this.salesmanList.push({
              salesCode: code,
              salesName: label
            });
          }
        } else if (staus == '4') {
          console.log(this.coInsurerList, '4共保人名称');
          var codeFlag = 0;

          if (this.coInsurerList) {
            this.coInsurerList.forEach(function (ele) {
              if (ele.codeCode == code) {
                codeFlag = 1;
              }
            });
          } else {
            this.coInsurerList = [];
          }

          if (codeFlag == 0) {
            this.coInsurerList.push({
              codeCode: code,
              codeCname: label
            });
          }
        } else if (staus == '5') {
          console.log(this.businessList, '5业务归属渠道');
          var codeFlag = 0;

          if (this.businessList) {
            this.businessList.forEach(function (ele) {
              if (ele.codeCode == code) {
                codeFlag = 1;
              }
            });
          } else {
            this.businessList = [];
          }

          if (codeFlag == 0) {
            this.businessList.push({
              codeCode: code,
              codeCname: label
            });
          }
        }
      }
    },
    initPolicynum: function initPolicynum() {
      var _this9 = this;

      if (this.protoMageForm.protocolMainDto.currencyType) {
        var codeCname;
        this.currencyList.forEach(function (item) {
          if (item.codeCode == _this9.protoMageForm.protocolMainDto.currencyType) {
            codeCname = item.codeCname;
            return;
          }
        });
        console.log('codeCname,p-i', codeCname);
        this.lowFeeData = '最低保费' + '(' + codeCname + ')';
      }
    },
    initRegion: function initRegion(cityStr) {
      var _this10 = this;

      this.options = [];
      getCon().forEach(function (ite) {
        var children = getChildCountry(ite.codeCode);
        var counChild = []; // 国家

        var newCount = []; //选中国家

        if (cityStr != '' && cityStr != null && cityStr != undefined) {
          var reg = new RegExp("null,", "g");
          var cStrs = cityStr.replace(reg, "");
          cStrs = cStrs.substring(0, cStrs.length - 1);
          var citycod = cStrs.split(',');
          var citycode = Array.from(new Set(citycod)); //提取

          if (citycode.length > 0) {
            citycode.forEach(function (itd) {
              if (itd.length >= 6) {
                var cots = getCountryCodeByCity(itd);
                newCount.push(cots);
              } else if (isNumber(itd)) {
                //中国大陆下面所以数据加载进入
                newCount.push("CHN");
              }
            });
          }
        }

        var _loop = function _loop(j) {
          // 获取之前选中的城市代码
          var cityChild = [];

          if (newCount.length > 0) {
            var newCo2 = Array.from(new Set(newCount));
            newCo2.forEach(function (itdds) {
              if (children[j].codeCode == itdds) {
                var _counts = getUnderCity(itdds);

                if (itdds == "CHN") {
                  _counts.forEach(function (ites) {
                    var cncity = [];
                    var cncityList = getProvinceCity(ites.codeCode);
                    cncityList.forEach(function (itcnty) {
                      var cntysds = {
                        'id': itcnty.codeCode,
                        'label': itcnty.codeCname,
                        'level': '4'
                      };
                      cncity.push(cntysds);
                    });
                    var city = {
                      'id': ites.codeCode,
                      'label': ites.codeCname,
                      'level': '3',
                      'children': cncity
                    };
                    cityChild.push(city);
                  });
                } else {
                  _counts.forEach(function (ites) {
                    var city = {
                      'id': ites.codeCode,
                      'label': ites.codeCname,
                      'level': '3'
                    };
                    cityChild.push(city);
                  });
                }
              }
            });
          }

          if (cityChild.length == 0) {
            cityChild = null;
          }

          var counts = {
            'id': children[j].codeCode,
            'label': children[j].codeCname,
            'level': '2',
            'children': cityChild
          };
          counChild.push(counts);
        };

        for (var j = 0; j < children.length; j++) {
          _loop(j);
        }

        if (counChild.length == 0) {
          counChild = null;
        }

        var cons = {
          'id': ite.codeCode,
          'label': ite.codeCname,
          'level': '1',
          'children': counChild
        };

        _this10.options.push(cons);
      });
    },
    init: function init() {
      var _this11 = this;

      this.activeName = 'first';
      var operationType = this.comingtype;
      var protocolNo = this.comingprotocolNo;

      if (operationType === 'edit') {
        this.viewDisable = false;
      } else if (operationType === 'view') {
        this.viewDisable = true;
      }

      if (protocolNo && (operationType === 'edit' || operationType === 'view')) {
        if (!protocolNo) return;
        findByNo({
          'protocolNo': protocolNo
        }).then(function (res) {
          console.log(res, 'resresresres');
          _this11.protoMageForm.protocolMainDto = res.protocolMainDto; // 基本信息

          _this11.protoMageForm.protocolApplicantDto = res.protocolApplicantDto || {}; // 投保人信息

          if (operationType === 'view') {
            if (_this11.protoMageForm.protocolApplicantDto.phone != null && _this11.protoMageForm.protocolApplicantDto.phone != '') {
              //投保人电话 脱敏
              _this11.protoMageForm.protocolApplicantDto.phone = _this11.setApplicationPhone(_this11.protoMageForm.protocolApplicantDto.phone);
            }

            if (_this11.protoMageForm.protocolApplicantDto.address != null && _this11.protoMageForm.protocolApplicantDto.address != '') {
              //投保人地址 脱敏
              _this11.protoMageForm.protocolApplicantDto.address = _this11.setApplicationAddress(_this11.protoMageForm.protocolApplicantDto.address);
            }

            if (_this11.protoMageForm.protocolApplicantDto.email != null && _this11.protoMageForm.protocolApplicantDto.email != '') {
              //投保人邮箱 脱敏
              _this11.protoMageForm.protocolApplicantDto.email = _this11.setApplicationEmail(_this11.protoMageForm.protocolApplicantDto.email);
            }
          }

          _this11.protocolInsuredDtoList = res.protocolInsuredDtoList || []; // 被保险人集合信息

          if (operationType === 'view') {
            _this11.protocolInsuredDtoList.forEach(function (item, index) {
              if (_this11.protocolInsuredDtoList[index].phone != null && _this11.protocolInsuredDtoList[index].phone != '') {
                //被保人电话 脱敏
                _this11.protocolInsuredDtoList[index].phone = _this11.setListPhone(_this11.protocolInsuredDtoList[index].phone);
              } //被保人地址 脱敏


              if (_this11.protocolInsuredDtoList[index].address != null && _this11.protocolInsuredDtoList[index].address != '') {
                _this11.protocolInsuredDtoList[index].address = _this11.setListAddress(_this11.protocolInsuredDtoList[index].address);
              } //被保人邮箱 脱敏


              if (_this11.protocolInsuredDtoList[index].email != null && _this11.protocolInsuredDtoList[index].email != '') {
                _this11.protocolInsuredDtoList[index].email = _this11.setApplicationEmail(_this11.protocolInsuredDtoList[index].email);
              }
            });
          }

          if (_this11.protocolInsuredDtoList.length > 0) {
            _this11.protocolInsuredDtoList.forEach(function (item, index) {
              var newArrList = [];
              newArrList.push(_this11.protocolInsuredDtoList[index].provinceCode);
              newArrList.push(_this11.protocolInsuredDtoList[index].cityCode);
              newArrList.push(_this11.protocolInsuredDtoList[index].areaCode);
              _this11.protocolInsuredDtoList[index].provinceLists = newArrList;
            }); // this.provinceLists = newArrInsured

          }

          _this11.protocolInsuredDtoList = res.protocolInsuredDtoList; // 被保险人集合信息

          if (res.protocolApplicantDto) {
            var newArrArea = [];
            newArrArea.push(res.protocolApplicantDto.provinceCode);
            newArrArea.push(res.protocolApplicantDto.cityCode);
            newArrArea.push(res.protocolApplicantDto.areaCode);
            _this11.provinceList = newArrArea;
            _this11.protoMageForm.protocolApplicantDto.provinceCode = res.protocolApplicantDto.provinceCode;
            _this11.protoMageForm.protocolApplicantDto.cityCode = res.protocolApplicantDto.cityCode;
            _this11.protoMageForm.protocolApplicantDto.areaCode = res.protocolApplicantDto.areaCode;
            _this11.protoMageForm.protocolApplicantDto.provinceName = res.protocolApplicantDto.provinceName;
            _this11.protoMageForm.protocolApplicantDto.cityName = res.protocolApplicantDto.cityName;
            _this11.protoMageForm.protocolApplicantDto.areaName = res.protocolApplicantDto.areaName;
          }

          _this11.putTheInsureList();

          _this11.putTheInsureList2();

          _this11.putTheInsureList3(); // if(this.protoMageForm.protocolMainDto.affiliationComName && this.protoMageForm.protocolMainDto.affiliationComCode) {
          //   let temparam = {
          //     companyCode: this.protoMageForm.protocolMainDto.affiliationComCode,
          //     companyName: this.protoMageForm.protocolMainDto.affiliationComName,
          //   }
          //   this.attAgencyList.push(temparam)
          // }


          if (_this11.protoMageForm.protocolMainDto.handler1Name && _this11.protoMageForm.protocolMainDto.handler1Code) {
            var temparas = {
              salesCode: _this11.protoMageForm.protocolMainDto.handler1Code,
              salesName: _this11.protoMageForm.protocolMainDto.handler1Name
            };

            _this11.salesmanList.push(temparas);
          }

          _this11.protoMageForm.protocolMainDto.emailReceiver = _this11.protoMageForm.protocolMainDto.emailReceiver.split(','); // 业务归属渠道

          if (_this11.protoMageForm.protocolMainDto.businessOwnerShipChannelName && _this11.protoMageForm.protocolMainDto.businessOwnerShipChannel) {
            var temparms = {
              codeCname: _this11.protoMageForm.protocolMainDto.businessOwnerShipChannelName,
              codeCode: _this11.protoMageForm.protocolMainDto.businessOwnerShipChannel
            };

            _this11.businessList.push(temparms);
          } // 中介机构


          if (_this11.protoMageForm.protocolMainDto.intermediaryOrganName && _this11.protoMageForm.protocolMainDto.intermediaryOrgan) {
            var temobj = {
              intermediaryOrganCode: _this11.protoMageForm.protocolMainDto.intermediaryOrgan,
              intermediaryOrganName: _this11.protoMageForm.protocolMainDto.intermediaryOrganName
            };

            _this11.intermediaryList.push(temobj);
          } //中介经办人


          if (_this11.protoMageForm.protocolMainDto.agentPersonCode && _this11.protoMageForm.protocolMainDto.agentPersonName) {
            var tembi = {
              agentManCode: _this11.protoMageForm.protocolMainDto.agentPersonCode,
              agentManName: _this11.protoMageForm.protocolMainDto.agentPersonName
            };

            _this11.managerList.push(tembi);
          }

          if (_this11.protocolInsuredDtoList.length > 3) {
            _this11.insuredStyle = 'insured-card';
          }

          if (_this11.protocolInsuredDtoList.length > 0) {
            if (!_this11.protocolInsuredDtoList[0].isUpdateInsuredName || _this11.protocolInsuredDtoList[0].isUpdateInsuredName === '') {
              _this11.protocolInsuredDtoList[0].isUpdateInsuredName = '0';
            }
          }

          _this11.protoMageForm.protocolCoinsDto = res.protocolCoinsDtoList[0] || {}; // 联共保基本信息

          _this11.protocolCoinsDtoList = res.protocolCoinsDtoList || []; // 联共保集合信息

          _this11.protocolRiskDtoList = res.protocolRiskDtoList || []; // 产品信息

          if (operationType === 'view' && res.endorseRecordDtoList && res.endorseRecordDtoList.length > 0) {
            _this11.endorseRecordDtoList = res.endorseRecordDtoList; // 批单信息
          }

          _this11.getProductList(res.protocolMainDto.insurancecompanyCode); // 获取产品信息


          _this11.engageInfoList(res.protocolMainDto.insurancecompanyCode); // 特别约定


          _this11.getLimitInfoList(res.protocolMainDto.insurancecompanyCode); // 免赔


          _this11.paramsData.insuranceCompanyCode = res.protocolMainDto.insurancecompanyCode;
          _this11.paramsData.userName = res.protocolApplicantDto.insuredName;
          _this11.paramsData.userCode = res.protocolApplicantDto.identifyNumber;
          console.log('是否有值1：', _this11.paramsData.userCode);

          _this11.dataDefinedList(); // 获取自定义表的类型
          //YCKK-1140


          _this11.convertOptionList(_this11.protoMageForm.protocolMainDto.intermediaryOrgan, '1', _this11.protoMageForm.protocolMainDto.intermediaryOrganName);

          _this11.convertOptionList(_this11.protoMageForm.protocolMainDto.agentPersonCode, '2', _this11.protoMageForm.protocolMainDto.agentPersonName);

          _this11.convertOptionList(_this11.protoMageForm.protocolMainDto.handler1Code, '3', _this11.protoMageForm.protocolMainDto.handler1Name);

          _this11.protocolCoinsDtoList.forEach(function (ele) {
            _this11.convertOptionList(ele.coinsCode, '4', ele.coinsName);
          });

          _this11.convertOptionList(_this11.protoMageForm.protocolMainDto.businessOwnerShipChannel, '5', _this11.protoMageForm.protocolMainDto.businessOwnerShipChannelName); // 获取产品起运地信息


          var citys = '';

          if (_this11.protocolRiskDtoList.length > 0) {
            _this11.protocolRiskDtoList.forEach(function (item, index) {
              if (item.protocolConveyintervalDto != null) {
                citys += item.protocolConveyintervalDto.coStartCityCode + ',';
                citys += item.protocolConveyintervalDto.exStartCityCode + ',';
                citys += item.protocolConveyintervalDto.coViaCityCode + ',';
                citys += item.protocolConveyintervalDto.exViaCityCode + ',';
                citys += item.protocolConveyintervalDto.coEndCityCode + ',';
                citys += item.protocolConveyintervalDto.exEndCityCode + ',';
              }

              if (item.protocolClauseDtoList.length > 0) {
                item.protocolClauseDtoList.forEach(function (clause, ind) {
                  if (clause.protocolConveyintervalDto != null) {
                    citys += clause.protocolConveyintervalDto.coEndCityCode + ',';
                    citys += clause.protocolConveyintervalDto.coStartCityCode + ',';
                    citys += clause.protocolConveyintervalDto.coViaCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exEndCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exStartCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exViaCityCode + ',';
                  }
                });
              }

              if (item.protocolEngageDtoList.length > 0) {
                item.protocolEngageDtoList.forEach(function (clause, ind) {
                  if (clause.protocolConveyintervalDto != null) {
                    citys += clause.protocolConveyintervalDto.coEndCityCode + ',';
                    citys += clause.protocolConveyintervalDto.coStartCityCode + ',';
                    citys += clause.protocolConveyintervalDto.coViaCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exEndCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exStartCityCode + ',';
                    citys += clause.protocolConveyintervalDto.exViaCityCode + ',';
                  }
                });
              }
            });
          }

          _this11.initRegion(citys);
        });
      } else {
        var opsd = this.options || [];

        if (opsd.length < 1) {
          this.initRegion('');
        }
      }
    },
    loadOptions: function loadOptions(_ref2) {
      var action = _ref2.action,
          parentNode = _ref2.parentNode,
          callback = _ref2.callback;

      if (action === LOAD_CHILDREN_OPTIONS) {
        switch (parentNode.level) {
          // 判断选择级别
          case '2':
            var city = getUnderCity(parentNode.id);
            var cityChild = [];
            city.forEach(function (item) {
              var chids;

              if (item.children) {
                chids = {
                  'id': item.codeCode,
                  'label': item.codeCname,
                  'level': '3',
                  'children': null
                };
              } else {
                chids = {
                  'id': item.codeCode,
                  'label': item.codeCname,
                  'level': '3'
                };
              }

              cityChild.push(chids);
            });
            parentNode.children = cityChild; // 增加子节点

            callback();
            break;

          case '3':
            var citycn = getProvinceCity(parentNode.id);
            var cityCldd = [];
            citycn.forEach(function (item) {
              var chids = {
                'id': item.codeCode,
                'label': item.codeCname,
                'level': '4'
              };
              cityCldd.push(chids);
            });
            parentNode.children = cityCldd; // 增加子节点

            callback();
            break;
        }
      }
    },

    /**
             * 修改被保险人信息  --暂时不处理
             */
    changeInsure: function changeInsure(e) {// if (e === '1') {
      //   this.insureDisable = false
      // } else {
      //   this.insureDisable = true
      // }
    },

    /**
             * 最外层信息切换
             */
    handleClick: function handleClick() {
      // 选择了产品基本信息查询后 才可以进行后面的录单
      console.log(this.activeName);

      if (this.activeName === 'second') {
        if (this.protoMageForm.protocolMainDto.protocolNo && this.protoMageForm.protocolMainDto.insurancecompanyCode) {
          this.initPolicynum();
          this.tableShow = true;
          this.protoInfo = false;
        } else {
          this.$message({
            type: 'warning',
            message: '请录入预约协议号进行查询协议基本信息'
          });
        }
      }

      console.log(this.activeName);
    },

    /**
             * 根据预约协议号查询协议信息
             */
    getPotoInfo: function getPotoInfo(e) {
      var _this12 = this;

      var protocolNo = this.protoMageForm.protocolMainDto.protocolNo;

      if (protocolNo) {
        console.log(protocolNo);
        findProtoBaseInfo({
          'protocolNo': protocolNo
        }).then(function (res) {
          console.log(res);

          if (res.rtnCode === '0000') {
            _this12.protoMageForm.protocolMainDto = res.protocolMainDto; // 基本信息

            _this12.protoMageForm.protocolApplicantDto = res.protocolApplicantDto || {}; // 投保人信息

            _this12.dataDefinedList(); // 获取自定义表的类型


            _this12.protocolInsuredDtoList = res.protocolInsuredDtoList || []; // 被保险人集合信息

            if (_this12.protocolInsuredDtoList.length > 0) {
              if (!_this12.protocolInsuredDtoList[0].isUpdateInsuredName || _this12.protocolInsuredDtoList[0].isUpdateInsuredName === '') {
                _this12.protocolInsuredDtoList[0].isUpdateInsuredName = '0';
              }
            }

            if (_this12.protocolInsuredDtoList.length > 3) {
              _this12.insuredStyle = 'insured-card';
            }

            _this12.protoMageForm.protocolCoinsDto = res.protocolCoinsDtoList[0] || {}; // 联共保基本信息

            _this12.protocolCoinsDtoList = res.protocolCoinsDtoList || []; // 联共保集合信息

            if (res.protocolMainDto.insurancecompanyCode) {
              _this12.getProductList(res.protocolMainDto.insurancecompanyCode); // 获取产品信息


              _this12.engageInfoList(res.protocolMainDto.insurancecompanyCode); // 特别约定


              _this12.getLimitInfoList(res.protocolMainDto.insurancecompanyCode); // 免赔

            }
          } else {
            console.log(res.rtnCode);

            _this12.cofirmBox(res.rtnMsg); // this.$router.go(-1)
            // 关闭导航栏
            // this.$store.dispatch('delVisitedViews', this.$route)

          }
        });
      } else {
        this.cofirmBox('请输入预约协议号！', '温馨提示');
      }

      console.log(protocolNo);
    },

    /**
             * 根据保险公司查询产品信息
             * @companyCode保险公司code
             */
    getProductList: function getProductList(companyCode) {
      var _this13 = this;

      // 获取产品集合
      _getProductList({
        'insuranceCompanyCode': companyCode
      }).then(function (res) {
        _this13.productList = _toConsumableArray(res);
      });
    },

    /**
             * 根据保险公司与产品查询条款信息
             * @companyCode保险公司code
             * @riskCode产品code
             * @clauseType 条款类型
             */
    getClauseListByType: function getClauseListByType(companyCode, riskCode, clauseType) {
      var _this14 = this;

      // 获取条款信息
      if (this.clauseList && this.clauseList.length > 0) {
        this.clauseList = [];
      }

      if (clauseType == '1') {
        this.isFlag = true;
      } else if (clauseType == '2') {
        // this.protocolClauseDto.itemCodeList = []
        // this.protocolClauseDto.itemCode = ''
        // this.protocolClauseDto.isNewOrOld = ''
        this.isFlag = false;
      }

      _getClauseListByType({
        'insuranceCompanyCode': companyCode,
        'riskCode': riskCode,
        'clauseType': clauseType
      }).then(function (res) {
        _this14.clauseList = _toConsumableArray(res);
      });
    },

    /**
             * 根据保险公司与条款查询责任信息
             * @companyCode保险公司code
             * @riskCode产品code
             */
    getKindList: function getKindList(companyCode, clauseCode, riskCode, clauseType) {
      var _this15 = this;

      // 获取责任信息
      if (this.kindList && this.kindList.length > 0) {
        this.kindList = [];
      }

      getKindInfoList({
        'insuranceCompanyCode': companyCode,
        'clauseCode': clauseCode,
        'riskCode': riskCode,
        'clauseType': clauseType
      }).then(function (res) {
        _this15.kindList = _toConsumableArray(res);
      });
    },

    /**
             * 根据保险公司查询特约集合
             * @companyCode保险公司code
             */
    engageInfoList: function engageInfoList(companyCode) {
      var _this16 = this;

      // 特约集合
      getEngageList({
        'insuranceCompanyCode': companyCode
      }).then(function (res) {
        _this16.engageList = _toConsumableArray(res);
      });
    },

    /**
             * 根据保险公司查询免赔集合
             * @companyCode保险公司code
             */
    getLimitInfoList: function getLimitInfoList(companyCode) {
      var _this17 = this;

      // 免赔集合
      getLimitList({
        'insuranceCompanyCode': companyCode
      }).then(function (res) {
        _this17.limitOptions = _toConsumableArray(res);
      });
    },

    /**
             * 分页查询
             */
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
    },

    /**
             * 下一页
             */
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.pagination.currentPage = val;
    },

    /**
             * 协议产品切换
             */
    handleInfoClick: function handleInfoClick() {},

    /**
             * 添加产品信息
             */
    addProduct: function addProduct() {
      this.tableShow = false;
      this.protoInfo = true;
      this.activeInfoName = 'first';
      var length = this.protocolRiskDtoList.length; // 系统条款集合含删除

      this.protocolRiskDto = {
        protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
        serialNo: length === 0 ? '1' : (parseInt(this.protocolRiskDtoList[length - 1].serialNo) + 1).toString(),
        riskName: '',
        riskCode: '',
        insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
        insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
        conveYanceWayList: [],
        conveYanceWay: '',
        currencyList: [],
        currency: '',
        optionalPack: '',
        optionalPackList: [],
        insureUpperLimit: '',
        insureDefault: '110',
        documentType: '',
        shipClassList: [],
        shipClass: '',
        shipType: '',
        shipAge: '',
        shipAgeEnd: '',
        termsOfTrade: '',
        termsList: [],
        // 自定义申报基准数组
        isAutoDeclare: '0',
        isAgreementBalance: '0',
        isAloneBalance: '0',
        allowReverseTime: '',
        rejectCargoTypeList: [],
        rejectCargoType: '',
        rejectCargoNameList: [],
        rejectCargoName: '',
        rejectCargoList: [],
        rejectCargo: '',
        isEnameRequired: '0'
      };

      if (this.clauseInfoType === true) {
        this.clauseInfoType = false;
      }

      if (this.premiumType === true) {
        this.premiumType = false;
      }

      if (this.engageType === true) {
        this.engageType = false;
      }

      if (this.editRiskState === true) {
        this.editRiskState = false;
      }

      if (this.riskView === true) {
        this.riskView = false;
      }
    },

    /**
             * 取消产品信息
             */
    cacleProtocolInfo: function cacleProtocolInfo() {
      if (this.protocolRiskDto != 'edit') {
        this.protocolRiskDto = {}; // 基本配置

        this.protocolClauseDtoList = []; // 条款责任配置信息

        this.protocolAmountDtoList = []; // 保额保费限制条件

        this.protocolShipageDtoList = []; // 船龄加费

        this.protocolKeepGrainDtoList = []; // 仓储加费

        this.protocolEngageDtoList = []; // 特约信息

        this.protocolLimitDtoList = []; // 免赔
      }

      this.tableShow = true;
      this.protoInfo = false;
    },

    /**
             * 协议产品切换
             */
    riskCodeChange: function riskCodeChange($event) {
      // if(this.protocolRiskDto.riskCode) {
      //   console.log(this.$refs.riskCodeSearch.hoverOption.currentLabel)
      //   this.$confirm('确认要切换该产品信息?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      this.protocolRiskDto.riskName = this.$refs.riskCodeSearch.hoverOption.currentLabel; // this.protoMageForm.protocolRiskDto = {} // 基本配置

      this.protocolClauseDtoList = []; // 条款责任配置信息

      this.protocolAmountDtoList = []; // 保额保费限制条件

      this.protocolShipageDtoList = []; // 船龄加费

      this.protocolKeepGrainDtoList = []; //仓储加费

      this.protocolEngageDtoList = []; // 特约信息

      this.protocolLimitDtoList = []; // 免赔
      // this.getClauseInfoList(this.protoMageForm.protocolMainDto.insurancecompanyCode, $event) // 获取条款信息
      // })
      // }
    },

    /**
             * 除外标的
             * @label
             */
    itemBaseChange: function itemBaseChange(label) {
      console.log(this.protocolRiskDto.rejectCargoList); // this.protocolRiskDto.rejectCargoList = []
      // label.forEach(item => {
      //   this.protocolRiskDto.rejectCargoList.push(item[1])
      // })
      // console.log(this.protocolRiskDto.rejectCargoList)

      console.log(label);
    },

    /**
             * 保存条则信息
             */
    saveProtocolRisk: function saveProtocolRisk() {
      var saveBaseState = true;
      this.riskView = true;

      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称');
        this.riskView = false;
        return false;
      } // else if (this.protocolRiskDto.insureUpperLimit && (this.protocolRiskDto.insureUpperLimit < 100 || this.protocolRiskDto.insureUpperLimit > 140)) {
      //   errorMsg = '投保加成上限应最低不小于100%，最高不高于140%'
      // }


      var protocolRiskDto = {
        protocolConveyintervalDto: {},
        // 协议基础配置信息
        protocolClauseDtoList: [],
        protocolAmountDtoList: [],
        protocolShipageDtoList: [],
        protocolKeepGrainDtoList: [],
        protocolEngageDtoList: [],
        protocolLimitDtoList: []
      };
      this.protocolRiskDto.validationFlag = '1';

      if (this.protocolRiskDto.conveYanceWayList && this.protocolRiskDto.conveYanceWayList.length > 0) {
        // 运输方式集合
        this.protocolRiskDto.conveYanceWay = this.protocolRiskDto.conveYanceWayList.join(',');
      } else {
        /* this.riskView = false
         this.cofirmBox('请选择运输方式')
         return false*/
      }

      if (this.protocolRiskDto.currencyList && this.protocolRiskDto.currencyList.length > 0) {
        // 币种集合
        this.protocolRiskDto.currency = this.protocolRiskDto.currencyList.join(',');
      } else {
        /*this.riskView = false
        this.cofirmBox('请选择币种')
        return false*/
      }

      if (this.protocolRiskDto.optionalPackList && this.protocolRiskDto.optionalPackList.length > 0) {
        // 可选包装集合
        this.protocolRiskDto.optionalPack = this.protocolRiskDto.optionalPackList.join(',');
      } else {
        /*this.riskView = false
        this.cofirmBox('请选择包装信息')
        return false*/
      }

      if (!this.protocolRiskDto.insureDefault || this.protocolRiskDto.insureDefault === '') {
        this.riskView = false;
        this.cofirmBox('默认投保加成不能为空');
        return false;
      } else if (this.protocolRiskDto.shipAge && this.protocolRiskDto.shipAgeEnd && Number(this.protocolRiskDto.shipAge) > Number(this.protocolRiskDto.shipAgeEnd)) {
        this.riskView = false;
        this.cofirmBox('船龄止期应大于船龄起期');
        return false;
      } // else if (this.protocolRiskDto.insureDefault && (this.protocolRiskDto.insureDefault < 100 || this.protocolRiskDto.insureDefault > 140)) {
      //   errorMsg = '默认投保加成应最低不小于100%，最高不高于140%'
      // }
      // else if (!this.protocolRiskDto.allowReverseTime || this.protocolRiskDto.allowReverseTime === '') {
      //   errorMsg = '允许倒签时间不能为空'
      // }
      else if (!this.protocolRiskDto.termsOfTrade || this.protocolRiskDto.termsOfTrade === []) {
          this.riskView = false;
          this.cofirmBox('申报基准不能为空');
          return false;
        } else if (!this.protocolRiskDto.isAutoDeclare || this.protocolRiskDto.isAutoDeclare === '') {
          this.riskView = false;
          this.cofirmBox('是否自动申报不能为空');
          return false;
        }

      if (saveBaseState) {
        if (this.protocolRiskDto.shipClassList && this.protocolRiskDto.shipClassList.length > 0) {
          // 船级社集合
          this.protocolRiskDto.shipClass = this.protocolRiskDto.shipClassList.join(',');
        }

        if (this.protocolRiskDto.termsList && this.protocolRiskDto.termsList.length > 0) {
          // 申报基准
          this.protocolRiskDto.termsOfTrade = this.protocolRiskDto.termsList.join(',');
        } else {
          this.protocolRiskDto.termsOfTrade = '';
        }

        if (this.protocolRiskDto.rejectCargoList && this.protocolRiskDto.rejectCargoList.length > 0) {
          // 除外货物标的Code集合
          this.protocolRiskDto.rejectCargo = this.protocolRiskDto.rejectCargoList.join(',');
        } // if (this.protocolRiskDto.rejectCargoNameList && this.protocolRiskDto.rejectCargoNameList.length > 0) { // 除外货物标的Name集合
        //   this.protocolRiskDto.rejectCargoName = this.protocolRiskDto.rejectCargoNameList.join(',')
        // }
        // if (this.protocolRiskDto.rejectCargoTypeList && this.protocolRiskDto.rejectCargoTypeList.length > 0) { // 除外货物标的[Code-childCode]集合
        //   this.protocolRiskDto.rejectCargoTypeList = []
        //   this.protocolRiskDto.rejectCargoType = ''
        // }


        if (this.riskConveyintervalDto.coStartContinentCodeList && this.riskConveyintervalDto.coStartContinentCodeList.length > 0) {
          // 含启运地洲
          this.riskConveyintervalDto.coStartContinentCode = this.riskConveyintervalDto.coStartContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coStartCountryCodeList && this.riskConveyintervalDto.coStartCountryCodeList.length > 0) {
          // 含启运地国家
          this.riskConveyintervalDto.coStartCountryCode = this.riskConveyintervalDto.coStartCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coStartCityCodeList && this.riskConveyintervalDto.coStartCityCodeList.length > 0) {
          // 含启运地城市
          this.riskConveyintervalDto.coStartCityCode = this.riskConveyintervalDto.coStartCityCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exStartContinentCodeList && this.riskConveyintervalDto.exStartContinentCodeList.length > 0) {
          // 除启运地洲
          this.riskConveyintervalDto.exStartContinentCode = this.riskConveyintervalDto.exStartContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exStartCountryCodeList && this.riskConveyintervalDto.exStartCountryCodeList.length > 0) {
          // 除启运地国家
          this.riskConveyintervalDto.exStartCountryCode = this.riskConveyintervalDto.exStartCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exStartCityCodeList && this.riskConveyintervalDto.exStartCityCodeList.length > 0) {
          // 除启运地城市
          this.riskConveyintervalDto.exStartCityCode = this.riskConveyintervalDto.exStartCityCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coViaContinentCodeList && this.riskConveyintervalDto.coViaContinentCodeList.length > 0) {
          // 含中转地洲
          this.riskConveyintervalDto.coViaContinentCode = this.riskConveyintervalDto.coViaContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coViaCountryCodeList && this.riskConveyintervalDto.coViaCountryCodeList.length > 0) {
          // 含中转地国家
          this.riskConveyintervalDto.coViaCountryCode = this.riskConveyintervalDto.coViaCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coViaCityCodeList && this.riskConveyintervalDto.coViaCityCodeList.length > 0) {
          // 含中转地城市
          this.riskConveyintervalDto.coViaCityCode = this.riskConveyintervalDto.coViaCityCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exViaContinentCodeList && this.riskConveyintervalDto.exViaContinentCodeList.length > 0) {
          // 除中转地洲
          this.riskConveyintervalDto.exViaContinentCode = this.riskConveyintervalDto.exViaContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exViaCountryCodeList && this.riskConveyintervalDto.exViaCountryCodeList.length > 0) {
          // 除中转地国家
          this.riskConveyintervalDto.exViaCountryCode = this.riskConveyintervalDto.exViaCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exViaCityCodeList && this.riskConveyintervalDto.exViaCityCodeList.length > 0) {
          // 除中转地城市
          this.riskConveyintervalDto.exViaCityCode = this.riskConveyintervalDto.exViaCityCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coEndContinentCodeList && this.riskConveyintervalDto.coEndContinentCodeList.length > 0) {
          // 含目的地洲
          this.riskConveyintervalDto.coEndContinentCode = this.riskConveyintervalDto.coEndContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coEndCountryCodeList && this.riskConveyintervalDto.coEndCountryCodeList.length > 0) {
          // 含目的地国家
          this.riskConveyintervalDto.coEndCountryCode = this.riskConveyintervalDto.coEndCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.coEndCityCodeList && this.riskConveyintervalDto.coEndCityCodeList.length > 0) {
          // 含目的地城市
          this.riskConveyintervalDto.coEndCityCode = this.riskConveyintervalDto.coEndCityCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exEndContinentCodeList && this.riskConveyintervalDto.exEndContinentCodeList.length > 0) {
          // 除目的地洲
          this.riskConveyintervalDto.exEndContinentCode = this.riskConveyintervalDto.exEndContinentCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exEndCountryCodeList && this.riskConveyintervalDto.exEndCountryCodeList.length > 0) {
          // 除目的地国家
          this.riskConveyintervalDto.exEndCountryCode = this.riskConveyintervalDto.exEndCountryCodeList.join(',');
        }

        if (this.riskConveyintervalDto.exEndCityCodeList && this.riskConveyintervalDto.exEndCityCodeList.length > 0) {
          // 除目的地城市
          this.riskConveyintervalDto.exEndCityCode = this.riskConveyintervalDto.exEndCityCodeList.join(',');
        }

        protocolRiskDto = this.protocolRiskDto; // 基本配置
        // 启运地（含/除）中转地（含/除）目的地（含除） --只要洲有值就新建该对象
        // if (this.riskConveyintervalDto.coStartContinentCode || this.riskConveyintervalDto.exStartContinentCode ||
        //   this.riskConveyintervalDto.coViaContinentCode || this.riskConveyintervalDto.exViaContinentCode ||
        //   this.riskConveyintervalDto.coEndContinentCode || this.riskConveyintervalDto.exEndContinentCode) {

        this.riskConveyintervalDto.protocolNo = this.protoMageForm.protocolMainDto.protocolNo;
        this.riskConveyintervalDto.serialNo = this.protocolRiskDto.serialNo;
        this.riskConveyintervalDto.insuranCecompanyCode = this.protoMageForm.protocolMainDto.insurancecompanyCode;
        this.riskConveyintervalDto.insuranCecompanyName = this.protoMageForm.protocolMainDto.insurancecompanyName;
        this.riskConveyintervalDto.riskCode = this.protocolRiskDto.riskCode;
        this.riskConveyintervalDto.riskName = this.protocolRiskDto.riskName;
        this.riskConveyintervalDto.validationFlag = '1';
        this.riskConveyintervalDto.flag = '1';
        protocolRiskDto.protocolConveyintervalDto = this.riskConveyintervalDto; // 运输起-中-终
        // }

        protocolRiskDto.protocolClauseDtoList = this.protocolClauseDtoList; // 条款责任配置信息

        protocolRiskDto.protocolAmountDtoList = this.protocolAmountDtoList; // 保额保费限制条件

        protocolRiskDto.protocolShipageDtoList = this.protocolShipageDtoList; // 船龄加费

        protocolRiskDto.protocolKeepGrainDtoList = this.protocolKeepGrainDtoList; // 仓储加费

        protocolRiskDto.protocolEngageDtoList = this.protocolEngageDtoList; // 特约信息

        protocolRiskDto.protocolLimitDtoList = this.protocolLimitDtoList; // 全单限额/免赔

        console.log(protocolRiskDto);

        if (this.protocolRiskDto.state === 'edit') {
          this.protocolRiskDtoList[this.protocolRiskDto.index] = protocolRiskDto;
        } else {
          this.protocolRiskDtoList.push(protocolRiskDto);
        }

        if (this.protocolRiskDto) {
          this.protocolRiskDto = {};
        }

        if (protocolRiskDto) {
          protocolRiskDto = {};
        }

        if (this.riskConveyintervalDto) {
          this.riskConveyintervalDto = {};
        }

        this.tableShow = true;
        this.protoInfo = false;
      }
    },

    /**
             * 删除产品信息
             */
    deleRiskDto: function deleRiskDto(row) {
      var _this18 = this;

      this.$confirm('是否要删除该产品信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // console.log(row)
        row.validationFlag = '0';

        _this18.$forceUpdate();
      });
    },

    /**
             * 修改或查看产品信息
             */
    handleInfo: function handleInfo(row, type, index) {
      console.log(row);
      this.activeInfoName = 'first';
      this.protocolRiskDto = Object.assign({
        state: '',
        index: -1
      }, row); // TODO -- 这么写是很low,但是没有办法

      if (this.protocolRiskDto.conveYanceWay) {
        // 运输方式
        this.protocolRiskDto.conveYanceWayList = this.protocolRiskDto.conveYanceWay.split(',');
      } else {
        this.protocolRiskDto.conveYanceWayList = [];
      }

      if (this.protocolRiskDto.currency) {
        // 币别
        this.protocolRiskDto.currencyList = this.protocolRiskDto.currency.split(',');
      } else {
        this.protocolRiskDto.currencyList = [];
      }

      if (this.protocolRiskDto.optionalPack) {
        // 包装方式
        this.protocolRiskDto.optionalPackList = this.protocolRiskDto.optionalPack.split(',');
      } else {
        this.protocolRiskDto.optionalPackList = [];
      }

      if (this.protocolRiskDto.shipClass) {
        // 船级社
        this.protocolRiskDto.shipClassList = this.protocolRiskDto.shipClass.split(',');
      } else {
        this.protocolRiskDto.shipClassList = [];
      }

      if (this.protocolRiskDto.termsOfTrade) {
        // 申报基准
        this.protocolRiskDto.termsList = this.protocolRiskDto.termsOfTrade.split(',');
      } else {
        this.protocolRiskDto.termsList = [];
      }

      if (this.protocolRiskDto.isOpen) {
        console.log('isOpen1:', this.protocolRiskDto.isOpen);
      } else {
        this.protocolRiskDto.isOpen = '0';
      }

      if (this.protocolRiskDto.rejectCargo) {
        // 除外货物标的Code
        this.protocolRiskDto.rejectCargoList = this.protocolRiskDto.rejectCargo.split(','); // this.protocolRiskDto.rejectCargoList.forEach(item => {
        //   this.protocolRiskDto.rejectCargoTypeList.push([item.substr(0, 2) + '00', item])
        // })
      } // if (this.protocolRiskDto.rejectCargoType) { // 除外货物标的Code-Name
      //   this.protocolRiskDto.rejectCargoTypeList = this.protocolRiskDto.rejectCargoType.split(',')
      // }
      // if (this.protocolRiskDto.rejectCargoName) { // 除外货物标的Name
      //   this.protocolRiskDto.rejectCargoNameList = this.protocolRiskDto.rejectCargoName.split(',')
      // }


      if (this.protocolRiskDto.protocolConveyintervalDto) {
        this.riskConveyintervalDto = this.protocolRiskDto.protocolConveyintervalDto;

        if (this.riskConveyintervalDto.coStartContinentCode) {
          // 含启运地洲
          this.riskConveyintervalDto.coStartContinentCodeList = this.riskConveyintervalDto.coStartContinentCode.split(','); // this.baseCoCountryList = getUnderCountry(this.riskConveyintervalDto.coStartContinentCodeList)
        }

        if (this.riskConveyintervalDto.coStartCountryCode) {
          // 含启运地国家
          this.riskConveyintervalDto.coStartCountryCodeList = this.riskConveyintervalDto.coStartCountryCode.split(','); // this.baseCoCityList = getUnderCity(this.riskConveyintervalDto.coStartCountryCodeList)
        }

        if (this.riskConveyintervalDto.coStartCityCode) {
          // 含启运地城市
          this.riskConveyintervalDto.coStartCityCodeList = this.riskConveyintervalDto.coStartCityCode.split(',');
        }

        if (this.riskConveyintervalDto.exStartContinentCode) {
          // 除启运地洲
          this.riskConveyintervalDto.exStartContinentCodeList = this.riskConveyintervalDto.exStartContinentCode.split(','); // this.baseExCountryList = getUnderCountry(this.riskConveyintervalDto.exStartContinentCodeList)
        }

        if (this.riskConveyintervalDto.exStartCountryCode) {
          // 除启运地国家
          this.riskConveyintervalDto.exStartCountryCodeList = this.riskConveyintervalDto.exStartCountryCode.split(','); // this.baseExCityList = getUnderCity(this.riskConveyintervalDto.exStartCountryCodeList)
        }

        if (this.riskConveyintervalDto.exStartCityCode) {
          // 除启运地城市
          this.riskConveyintervalDto.exStartCityCodeList = this.riskConveyintervalDto.exStartCityCode.split(',');
        }

        if (this.riskConveyintervalDto.coViaContinentCode) {
          // 含中转地洲
          this.riskConveyintervalDto.coViaContinentCodeList = this.riskConveyintervalDto.coViaContinentCode.split(','); // this.baseCoViaCountryList = getUnderCountry(this.riskConveyintervalDto.coViaContinentCodeList)
        }

        if (this.riskConveyintervalDto.coViaCountryCode) {
          // 含中转地国家
          this.riskConveyintervalDto.coViaCountryCodeList = this.riskConveyintervalDto.coViaCountryCode.split(','); // this.baseCoViaCityList = getUnderCity(this.riskConveyintervalDto.coViaCountryCodeList)
        }

        if (this.riskConveyintervalDto.coViaCityCode) {
          // 含中转地城市
          this.riskConveyintervalDto.coViaCityCodeList = this.riskConveyintervalDto.coViaCityCode.split(',');
        }

        if (this.riskConveyintervalDto.exViaContinentCode) {
          // 除中转地洲
          this.riskConveyintervalDto.exViaContinentCodeList = this.riskConveyintervalDto.exViaContinentCode.split(','); // this.baseExViaCountryList = getUnderCountry(this.riskConveyintervalDto.exViaContinentCodeList)
        }

        if (this.riskConveyintervalDto.exViaCountryCode) {
          // 除中转地国家
          this.riskConveyintervalDto.exViaCountryCodeList = this.riskConveyintervalDto.exViaCountryCode.split(','); // this.baseExViaCityList = getUnderCity(this.riskConveyintervalDto.exViaCountryCodeList)
        }

        if (this.riskConveyintervalDto.exViaCityCode) {
          // 除中转地城市
          this.riskConveyintervalDto.exViaCityCodeList = this.riskConveyintervalDto.exViaCityCode.split(',');
        }

        if (this.riskConveyintervalDto.coEndContinentCode) {
          // 含目的地洲
          this.riskConveyintervalDto.coEndContinentCodeList = this.riskConveyintervalDto.coEndContinentCode.split(','); // this.baseCoEndCountryList = getUnderCountry(this.riskConveyintervalDto.coEndContinentCodeList)
        }

        if (this.riskConveyintervalDto.coEndCountryCode) {
          // 含目的地国家
          this.riskConveyintervalDto.coEndCountryCodeList = this.riskConveyintervalDto.coEndCountryCode.split(','); // this.baseCoEndCityList = getUnderCity(this.riskConveyintervalDto.coEndCountryCodeList)
        }

        if (this.riskConveyintervalDto.coEndCityCode) {
          // 含目的地城市
          this.riskConveyintervalDto.coEndCityCodeList = this.riskConveyintervalDto.coEndCityCode.split(',');
        }

        if (this.riskConveyintervalDto.exEndContinentCode) {
          // 除目的地洲
          this.riskConveyintervalDto.exEndContinentCodeList = this.riskConveyintervalDto.exEndContinentCode.split(','); // this.baseExEndCountryList = getUnderCountry(this.riskConveyintervalDto.exEndContinentCodeList)
        }

        if (this.riskConveyintervalDto.exEndCountryCode) {
          // 除目的地国家
          this.riskConveyintervalDto.exEndCountryCodeList = this.riskConveyintervalDto.exEndCountryCode.split(','); // this.baseExEndCityList = getUnderCity(this.riskConveyintervalDto.exEndCountryCodeList)
        }

        if (this.riskConveyintervalDto.exEndCityCode) {
          // 除目的地城市
          this.riskConveyintervalDto.exEndCityCodeList = this.riskConveyintervalDto.exEndCityCode.split(',');
        }
      }

      this.protocolClauseDtoList = row.protocolClauseDtoList; // 条款责任信息

      this.protocolAmountDtoList = row.protocolAmountDtoList; // 保额保费限制条件

      this.protocolShipageDtoList = row.protocolShipageDtoList; // 船龄加费

      this.protocolKeepGrainDtoList = row.protocolKeepGrainDtoList; // 仓储加费

      this.protocolEngageDtoList = row.protocolEngageDtoList; // 特约

      this.protocolLimitDtoList = row.protocolLimitDtoList; // 免赔

      if (type === 'edit') {
        this.protocolRiskDto.state = 'edit';
        this.protocolRiskDto.index = index;
        this.editRiskState = true;
        this.riskView = false;
      } else if (type === 'view') {
        this.riskView = true;
      }

      if (this.clauseInfoType === true) {
        this.clauseInfoType = false;
      }

      if (this.premiumType === true) {
        this.premiumType = false;
      }

      if (this.engageType === true) {
        this.engageType = false;
      }

      this.tableShow = false;
      this.protoInfo = true;
    },

    /**
             * 基础配置标的信息处理
             */
    selectBaseItemChange: function selectBaseItemChange(e) {
      var arrNew = []; // var dataLength = this.protocolRiskDto.rejectCargoTypeList.length

      var eleng = e.length;

      for (var i = 0; i < eleng; i++) {
        var codeCode = e[i].substring(0, 4);
        arrNew.push(codeCode);
      }

      this.protocolRiskDto.rejectCargoTypeList = Object.assign([], e);
      this.$refs.baseItemTree.setCheckedKeys(arrNew); // 设置勾选的值
    },
    handleBaseItemCheckChange: function handleBaseItemCheckChange() {
      var res = this.$refs.baseItemTree.getCheckedNodes(true, true); // 这里两个true，1. 是否只是叶子节点 2. 是否包含被选节点（就是使得选择的时候不包含父节点）

      var assList = this.$refs.baseItemTree.getCheckedKeys(true, true); // const test = this.$refs.baseItemTree.getHalfCheckedKeys(true, true)
      // console.log('test' + test)
      // console.log('assList' + assList)

      var arrLabel = [];
      var arr = [];
      res.forEach(function (item) {
        arrLabel.push(item.codeCname);
        arr.push(item.codeCode + '-' + item.codeCname);
      });
      this.protocolRiskDto.rejectCargoTypeList = arr;
      this.protocolRiskDto.rejectCargoList = assList;
      this.protocolRiskDto.rejectCargoNameList = arrLabel;
      console.log('rejectCargoTypeList', this.protocolRiskDto.rejectCargoTypeList);
      console.log('rejectCargoList', this.protocolRiskDto.rejectCargoList);
      console.log('rejectCargoNameList', this.protocolRiskDto.rejectCargoNameList); // console.log('arr:' + JSON.stringify(arr))
      // console.log('arrLabel:' + arrLabel)
    },

    /**
             * 船级社多选
             */
    shipChecked: function shipChecked(event) {
      console.log(this.$refs.shipSearch.hoverOption.currentLabel);
      console.log(event);
    },

    /**
             *  申报基准多选
             */
    reportChecked: function reportChecked(event) {
      console.log(this.$refs.reportSearch.hoverOption.currentLabel);
      console.log(event);
    },

    /**
             * 基础配置--根据洲获取国家
             * @$event 选中的洲集合
             * @codeType 触发方法类型
             */
    continentChange: function continentChange($event, codeType) {
      if ($event && $event.length > 0) {
        if (codeType === 'baseCoCountry') {
          this.baseCoCountryList = getUnderCountry($event);
        } else if (codeType === 'baseExCountry') {
          this.baseExCountryList = getUnderCountry($event);
        } else if (codeType === 'baseCoViaCountry') {
          this.baseCoViaCountryList = getUnderCountry($event);
        } else if (codeType === 'baseExViaCountry') {
          this.baseExViaCountryList = getUnderCountry($event);
        } else if (codeType === 'baseCoEndCountry') {
          this.baseCoEndCountryList = getUnderCountry($event);
        } else if (codeType === 'baseExEndCountry') {
          this.baseExEndCountryList = getUnderCountry($event);
        }
      }
    },

    /**
             * 基础配置--根据国家获取城市
             * @$event 选中的国家集合
             * @codeType 触发方法类型
             */
    countryChange: function countryChange($event, codeType) {
      if ($event && $event.length > 0) {
        if (codeType === 'baseCoCity') {
          this.baseCoCityList = getUnderCity($event);
        } else if (codeType === 'baseExCity') {
          this.baseExCityList = getUnderCity($event);
        } else if (codeType === 'baseCoViaCity') {
          this.baseCoViaCityList = getUnderCity($event);
        } else if (codeType === 'baseExViaCity') {
          this.baseExViaCityList = getUnderCity($event);
        } else if (codeType === 'baseCoEndCity') {
          this.baseCoEndCityList = getUnderCity($event);
        } else if (codeType === 'baseExEndCity') {
          this.baseExEndCityList = getUnderCity($event);
        }
      }
    },

    /**
             * 添加条款
             */
    addClause: function addClause() {
      this.expands = [];

      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称！', '温馨提示');
      } else {
        if (this.clauseView === true) {
          this.clauseView = false;
        }

        var length = this.protocolClauseDtoList.length; // 系统条款集合含删除

        var listInfo = [];

        if (length > 0) {
          listInfo = this.protocolClauseDtoList.filter(function (data) {
            return data.validationFlag === '1';
          }); // 系统条款集合不含
        }

        if (listInfo.length > 0) {
          var rowInfo = Object.assign({
            state: ''
          }, listInfo[listInfo.length - 1]);
          this.protocolClauseDto = {
            protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
            serialNo: length === 0 ? '1' : (parseInt(this.protocolClauseDtoList[length - 1].serialNo) + 1).toString(),
            insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
            insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
            riskCode: this.protocolRiskDto.riskCode,
            riskName: this.protocolRiskDto.riskName,
            freightRateList: rowInfo.freightRateList || [],
            freightRateType: rowInfo.freightRateType || '',
            clauseType: '',
            clauseCode: '',
            clauseName: '',
            kindCode: '',
            kindName: '',
            termsOfTrade: rowInfo.termsOfTrade || '',
            termsOfTradeList: rowInfo.termsOfTradeList || [],
            itemTypeList: rowInfo.itemTypeList || [],
            itemType: rowInfo.itemType || '',
            itemCodeList: rowInfo.itemCodeList || [],
            itemCode: rowInfo.itemCode || '',
            itemNameList: rowInfo.itemNameList || [],
            itemName: rowInfo.itemName || '',
            conveyanceWayList: rowInfo.conveyanceWayList || [],
            conveyanceWay: rowInfo.conveyanceWay || '',
            optionalPack: rowInfo.optionalPack || '',
            isPackagList: rowInfo.isPackagList || [],
            isPackaging: rowInfo.isPackaging || '',
            isContainer: rowInfo.isContainer || '',
            specialAdditionToScale: rowInfo.specialAdditionToScale || '',
            isNewOrOld: rowInfo.isNewOrOld || '',
            feeRate: '',
            clauseRemark: '',
            validationFlag: '1',
            theInsured: rowInfo.theInsured || ''
          }; // 新增时初始化条则数据

          this.insertClauseInit(rowInfo);
        } else {
          this.protocolClauseDto = {
            protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
            serialNo: length === 0 ? '1' : (parseInt(this.protocolClauseDtoList[length - 1].serialNo) + 1).toString(),
            insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
            insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
            riskCode: this.protocolRiskDto.riskCode,
            riskName: this.protocolRiskDto.riskName,
            freightRateList: [],
            freightRateType: '',
            clauseType: '',
            clauseCode: '',
            clauseName: '',
            kindCode: '',
            kindName: '',
            itemTypeList: [],
            itemType: '',
            itemCodeList: [],
            itemCode: '',
            itemNameList: [],
            itemName: '',
            conveyanceWayList: [],
            conveyanceWay: '',
            optionalPack: '',
            isPackagList: [],
            termsOfTrade: '',
            termsOfTradeList: [],
            isPackaging: '',
            isContainer: '',
            startSiteCountryCode: '',
            startSiteCountryName: '',
            startSiteCityCode: '',
            startSiteCityName: '',
            viaSiteCountryCode: '',
            viaSiteCountryName: '',
            viaSiteCityCode: '',
            viaSiteCityName: '',
            endSiteCountryCode: '',
            endSiteCountryName: '',
            endSiteCityCode: '',
            endSiteCityName: '',
            specialAdditionToScale: '',
            isNewOrOld: '01',
            feeRate: '',
            clauseRemark: '',
            validationFlag: '1',
            theInsured: ''
          };
        }

        this.clauseInfoType = true;
      }
    },

    /**
             * 新增时条则初始化
             * @ rowInfo 选中对象
             */
    insertClauseInit: function insertClauseInit(rowInfo) {
      if (this.protocolClauseDto.itemCode) {
        // 除外货物标的Code
        this.protocolClauseDto.itemCodeList = this.protocolClauseDto.itemCode.split(','); // this.protocolClauseDto.itemTypeList = []
        // this.protocolClauseDto.itemCodeList.forEach(item => {
        //   this.protocolClauseDto.itemTypeList.push([item.substr(0, 2) + '00', item])
        // })
      }

      if (this.protocolClauseDto.freightRateType) {
        // 可选费率因子
        if (rowInfo && rowInfo.protocolConveyintervalDto) {
          this.protocolConveyintervalDto = rowInfo.protocolConveyintervalDto;
        }

        if (this.protocolClauseDto.freightRateList && this.protocolClauseDto.freightRateList.length > 0) {
          this.freightRateInitialization();
        } else {
          this.protocolClauseDto.freightRateList = this.protocolClauseDto.freightRateType.split(',');
          this.freightRateInitialization();
        }
      }

      this.protocolClauseDto.protocolAddrisksfactorDto = {};
    },

    /**
             * 条款名称选择
             * @event 传入条款信息
             */
    getClauseType: function getClauseType() {
      this.protocolClauseDto.clauseCode = '';
      this.protocolClauseDto.clauseName = '';
      this.protocolClauseDto.kindCode = '';
      this.protocolClauseDto.kindName = '';
      this.getClauseListByType(this.protoMageForm.protocolMainDto.insurancecompanyCode, this.protocolRiskDto.riskCode, this.protocolClauseDto.clauseType); // 获取条款信息

      if (this.protocolClauseDto.clauseType === '2') {
        this.protocolAddrisksfactorDto = {
          protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
          serialNo: this.protocolClauseDto.serialNo,
          insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
          insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
          riskCode: this.protocolRiskDto.riskCode,
          riskName: this.protocolRiskDto.riskName,
          clauseType: this.protocolClauseDto.clauseType,
          clauseName: '',
          clauseCode: '',
          kindCode: '',
          kindName: '',
          selectCondFlagList: [],
          selectCondFlag: '',
          itemTypeList: [],
          itemType: '',
          itemCodeList: [],
          itemCode: '',
          packgeList: [],
          // 包装数组
          conveyanceWayList: [],
          conveyanceWay: '',
          isRefrigeRate: '',
          isPackagingNow: '',
          validationFlag: '1',
          theInsured: ''
        };

        if (this.triggerItemState === true) {
          this.triggerItemState = false;
        }

        if (this.triggerTransModeState === true) {
          this.triggerTransModeState = false;
        }

        if (this.triggerRefrigerateState === true) {
          this.triggerRefrigerateState = false;
        }

        if (this.packState === true) {
          this.packState = false;
        }
      } else {
        if (this.protocolAddrisksfactorDto) {
          this.protocolAddrisksfactorDto = {};
        }
      }
    },

    /**
             * 条款名称选择
             */
    getClauseName: function getClauseName() {
      this.protocolClauseDto.kindCode = '';
      this.protocolClauseDto.kindName = '';
      this.protocolClauseDto.clauseName = this.$refs.clauseCodeSearch.hoverOption.currentLabel;
      this.getKindList(this.protoMageForm.protocolMainDto.insurancecompanyCode, this.protocolClauseDto.clauseCode, this.protocolRiskDto.riskCode, this.protocolClauseDto.clauseType);
    },

    /**
             * 条则费率配置标的
             * @label
             */
    itemClauseChange: function itemClauseChange(label) {// console.log('protocolClauseDto.itemTypeList', this.protocolClauseDto.itemCodeList)
      // this.protocolClauseDto.itemCodeList = []
      // label.forEach(item => {
      //   this.protocolClauseDto.itemCodeList.push(item[1])
      // })
      // console.log(this.protocolClauseDto.itemCodeList)
      // console.log(label)
    },

    /**
             * 获取责任信息
             * @$event 类型
             */
    getkindName: function getkindName() {
      this.protocolClauseDto.kindName = this.$refs.kindCodeSearch.hoverOption.currentLabel;
    },

    /**
             * 可选费率因子确认
             * @$event 选中状态
             * @item 费率类型
             */
    checkedClause: function checkedClause($event, item) {
      if (item === '1') {
        if ($event) {
          this.transSection = true;
        } else {
          this.transSection = false;
          this.protocolConveyintervalDto = {};
        }
      } else if (item === '2') {
        if ($event) {
          this.containerState = true;
        } else {
          this.containerState = false;
          this.protocolClauseDto.isContainer = '';
        }
      } else if (item === '3') {
        if ($event) {
          this.packingstate = true;
        } else {
          this.packingstate = false;
          this.protocolClauseDto.isPackagList = [];
          this.protocolClauseDto.isPackaging = '';
        }
      } else if (item === '4') {
        if ($event) {
          this.transModeState = true;
        } else {
          this.transModeState = false;
          this.protocolClauseDto.conveyanceWayList = [];
          this.protocolClauseDto.conveyanceWay = '';
        }
      } else if (item === '5') {
        if ($event) {
          this.markupState = true;
        } else {
          this.markupState = false;
          this.protocolClauseDto.specialAdditionToScale = '';
        }
      } else if (item === '6') {
        if ($event) {
          this.reportState = true;
        } else {
          this.reportState = false;
          this.protocolClauseDto.termsOfTradeList = [];
          this.protocolClauseDto.termsOfTrade = '';
        }
      } else if (item === '7') {
        this.theInsuredList = [];

        if ($event) {
          this.theInsuredState = true;
          this.putTheInsureList();
        } else {
          this.theInsuredState = false;
          this.protocolClauseDto.theInsured = '';
        }
      }
    },
    //拷贝基本信息里的被保险人
    putTheInsureList: function putTheInsureList() {
      var _this19 = this;

      this.theInsuredList = [];
      this.protocolInsuredDtoList.forEach(function (ele, index) {
        if (ele.insuredName && ele.idEntifyTypeCode && ele.identifyNumber && ele.address) {
          _this19.theInsuredList.push({
            codeName: ele.insuredName,
            codeCode: ele.identifyNumber
          });
        }
      });
    },

    /**
             * 可选触发条件选择
             * @$event 类型
             */
    checkedCondFlag: function checkedCondFlag($event, item) {
      if (item === '1') {
        if ($event) {
          this.triggerItemState = true;
        } else {
          this.triggerItemState = false;
          this.protocolAddrisksfactorDto.itemTypeList = [];
          this.protocolAddrisksfactorDto.itemType = '';
          this.protocolAddrisksfactorDto.itemCodeList = [];
          this.protocolAddrisksfactorDto.itemCode = '';
        }
      } else if (item === '2') {
        if ($event) {
          this.triggerTransModeState = true;
        } else {
          this.triggerTransModeState = false;
          this.protocolAddrisksfactorDto.conveyanceWayList = [];
          this.protocolAddrisksfactorDto.conveyanceWay = '';
        }
      } else if (item === '3') {
        if ($event) {
          this.triggerRefrigerateState = true;
        } else {
          this.triggerRefrigerateState = false;
          this.protocolAddrisksfactorDto.isRefrigeRate = '';
        }
      } else if (item === '4') {
        if ($event) {
          this.packState = true;
        } else {
          this.packState = false;
          this.protocolAddrisksfactorDto.packgeList = [];
          this.protocolAddrisksfactorDto.isPackagingNow = '';
        }
      } else if (item == '5') {
        this.theInsuredList3 = [];

        if ($event) {
          this.theInsuredState3 = true;
          this.putTheInsureList3();
        } else {
          this.theInsuredState3 = false;
          this.protocolAddrisksfactorDto.theInsured = '';
        }
      } // console.log($event)

    },
    //拷贝基本信息里的被保险人
    putTheInsureList3: function putTheInsureList3() {
      var _this20 = this;

      this.theInsuredList3 = [];
      this.protocolInsuredDtoList.forEach(function (ele, index) {
        if (ele.insuredName && ele.idEntifyTypeCode && ele.identifyNumber && ele.address) {
          _this20.theInsuredList3.push({
            codeName: ele.insuredName,
            codeCode: ele.identifyNumber
          });
        }
      });
    },

    /**
             * 条件触发附加险标的类型处理
             * @label 类型
             */
    itemAddriskChange: function itemAddriskChange(label) {// console.log('protocolAddrisksfactorDto.itemCodeList', this.protocolAddrisksfactorDto.itemCodeList)
      // this.protocolAddrisksfactorDto.itemCodeList = []
      // label.forEach(item => {
      //   this.protocolAddrisksfactorDto.itemCodeList.push(item[1])
      // })
      // console.log(this.protocolAddrisksfactorDto.itemCodeList)
      //  console.log(label)
    },

    /**
             * 根据洲获取国家/根据国家获取城市
             */
    // continentChange($event, codeLever) {
    //   console.log($event)
    //   if ($event.length > 0) {
    //     continentList({ 'codeCode': $event, 'codeLever': codeLever }).then(res => {
    //       if (codeLever === '1') {
    //         this.countryList = res
    //       } else if (codeLever === '2') {
    //         this.cityList = res
    //       }
    //     })
    //   }
    // },

    /**
             * 条则配置--根据洲获取国家
             * @$event 选中的洲集合
             * @codeType 触发方法类型
             */
    clauseContinentChange: function clauseContinentChange($event, codeType) {
      // console.log($event)
      if ($event && $event.length > 0) {
        if (codeType === 'clauseCoContinent') {
          this.clauseCoCountryList = getUnderCountry($event);
        } else if (codeType === 'clauseExContinent') {
          this.clauseExCountryList = getUnderCountry($event);
        } else if (codeType === 'clauseCoViaContinent') {
          this.clauseCoViaCountryList = getUnderCountry($event);
        } else if (codeType === 'clauseExViaContinent') {
          this.clauseExViaCountryList = getUnderCountry($event);
        } else if (codeType === 'clauseCoEndContinent') {
          this.clauseCoEndCountryList = getUnderCountry($event);
        } else if (codeType === 'clauseExEndContinent') {
          this.clauseExEndCountryList = getUnderCountry($event);
        }
      }
    },

    /**
             * 条则配置--根据国家获取城市
             * @$event 选中的国家集合
             * @codeType 触发方法类型
             */
    clauseCountryChange: function clauseCountryChange($event, codeType) {
      if ($event && $event.length > 0) {
        if (codeType === 'clauseCoCountry') {
          this.clauseCoCityList = getUnderCity($event);
        } else if (codeType === 'clauseExCountry') {
          this.clauseExCityList = getUnderCity($event);
        } else if (codeType === 'clauseCoViaCountry') {
          this.clauseCoViaCityList = getUnderCity($event);
        } else if (codeType === 'clauseExViaCountry') {
          this.clauseExViaCityList = getUnderCity($event);
        } else if (codeType === 'clauseCoEndCountry') {
          this.clauseCoEndCityList = getUnderCity($event);
        } else if (codeType === 'clauseExEndCountry') {
          this.clauseExEndCityList = getUnderCity($event);
        }
      }
    },
    toogleExpand: function toogleExpand(type, row, indexInfo) {
      this.clauseInfoType = false; // console.log('3500-scope.row:', row)
      //this.$refs.table.toggleRowExpansion(row)

      var rowInfo = Object.assign({
        state: '',
        indexInfo: -1
      }, row); // var rowInfo = this.deepCopy({ state: '', indexInfo: -1, ...row })

      console.log('修改条款时触发', rowInfo);
      this.getClauseListByType(this.protoMageForm.protocolMainDto.insurancecompanyCode, rowInfo.riskCode, rowInfo.clauseType); // 获取条款信息

      this.getKindList(this.protoMageForm.protocolMainDto.insurancecompanyCode, rowInfo.clauseCode, this.protocolRiskDto.riskCode, rowInfo.clauseType, ''); // 获取责任信息

      this.itemInitialization(rowInfo);

      if (type === 'view') {
        console.log('2222222222222');
        this.clauseView = true;
      } else {
        console.log('2333333333333');
        this.clauseView = false; // this.protocolClauseDto.indexInfo = indexInfo
        // =====================  开始修改  ====================================
        //    思路： 循环整个数组， 如果标记为删除， i1 增加， 否则 i2 增加
        //          当i2 大于 传入的  indexInfo 时， 结束循环， 真正的索引下标为 i1+i2

        var i1 = 0,
            i2 = 0;

        for (var di = 0, dlen = this.protocolClauseDtoList.length; di < dlen; di++) {
          var ditem = this.protocolClauseDtoList[di];

          if (ditem.validationFlag === '0') {
            i1++;
          } else {
            i2++;
          }

          if (i2 > indexInfo) {
            this.protocolClauseDto.indexInfo = i2 + i1 - 1;
            break;
          }
        } // =====================  结束修改  ====================================


        console.log('此时的索引：', this.protocolClauseDto.indexInfo);
        console.log('条款编辑时的数据的状态：', this.protocolClauseDto);
        this.saveClauseType = true;
        this.protocolClauseDto.state = 'edit';
      } //this.clauseInfoType = true


      this.$refs.table.toggleRowExpansion(row); //this.$forceUpdate()
    },
    expandSelect: function expandSelect(row, expandedRows) {
      // console.log('expandedRows', expandedRows)
      // console.log('row', row)
      var that = this;

      if (expandedRows.length) {
        that.expands = [];

        if (row) {
          that.expands.push(row.serialNo); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      } // console.log('that.expands', that.expands)

    },

    /**
             * 删除条款
             */
    deleteClause: function deleteClause(row) {
      this.$confirm('是否要删除该条款信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // console.log(row)
        row.validationFlag = '0';

        if (row.protocolConveyintervalDto) {
          row.protocolConveyintervalDto.validationFlag = '0';
        }

        if (row.protocolAddrisksfactorDto) {
          row.protocolAddrisksfactorDto.validationFlag = '0';
        }
      });
      this.$forceUpdate();
    },

    /**
             * 修改条款
             */
    updateAndViewClause: function updateAndViewClause(type, row, indexInfo) {
      // console.log(row)
      var rowInfo = Object.assign({
        state: '',
        indexInfo: -1
      }, row);
      this.getClauseListByType(this.protoMageForm.protocolMainDto.insurancecompanyCode, rowInfo.riskCode, rowInfo.clauseType); // 获取条款信息

      this.getKindList(this.protoMageForm.protocolMainDto.insurancecompanyCode, rowInfo.clauseCode, this.protocolRiskDto.riskCode, rowInfo.clauseType); // 获取责任信息

      this.itemInitialization(rowInfo);

      if (type === 'view') {
        this.clauseView = true;
      } else {
        this.clauseView = false;
        this.protocolClauseDto.indexInfo = indexInfo;
        this.protocolClauseDto.state = 'edit';
      }

      this.clauseInfoType = true;
      this.$forceUpdate();
    },

    /**
             * 条款信息取消
             */
    closeClause: function closeClause() {
      this.expands = [];
      this.clauseInfoType = false;

      if (this.protocolClauseDto) {
        this.protocolClauseDto = {};
      }

      if (this.protocolAddrisksfactorDto) {
        this.protocolAddrisksfactorDto = {};
      }

      if (this.protocolConveyintervalDto) {
        this.protocolConveyintervalDto = {};
      }
    },

    /**
             * 条款信息保存
             */
    saveClause: function saveClause() {
      var _this21 = this;

      this.expands = [];
      var checkClaseInfo = true;

      if (!this.protocolClauseDto.clauseType || this.protocolClauseDto.clauseType === '') {
        checkClaseInfo = false;
        this.cofirmBox('请选择条款类型！', '温馨提示');
        return false;
      } else if (!this.protocolClauseDto.clauseCode || this.protocolClauseDto.clauseCode === '') {
        checkClaseInfo = false;
        this.cofirmBox('请选择条款名称！', '温馨提示');
        return false;
      } else if (!this.protocolClauseDto.kindCode || this.protocolClauseDto.kindCode === '') {
        checkClaseInfo = false;
        this.cofirmBox('请选择责任名称！', '温馨提示');
        return false;
      } else if (!this.protocolClauseDto.itemCodeList || this.protocolClauseDto.itemCodeList.length === 0) {
        /*checkClaseInfo = false
        this.cofirmBox('请选择标的类型！', '温馨提示')
        return false*/

        /*} else if (!this.protocolClauseDto.isNewOrOld || this.protocolClauseDto.isNewOrOld === '') {
          checkClaseInfo = false
          this.cofirmBox('请选择货物新旧标志', '温馨提示')
          return false*/
      } else if (!this.protocolClauseDto.feeRate || this.protocolClauseDto.feeRate === '') {
        checkClaseInfo = false;
        this.cofirmBox('费率不能为空', '温馨提示');
        return false;
      } else if (this.protocolClauseDto.feeRate && this.protocolClauseDto.feeRate.toString().indexOf('.') > -1) {
        if (this.protocolClauseDto.feeRate.toString().split('.')[1].length > 10) {
          this.protocolClauseDto.feeRate = '';
          checkClaseInfo = false;
          this.cofirmBox('费率小数点后最多只能输入10位', '温馨提示');
          return false;
        }
      }

      if (this.protocolClauseDto.itemCodeList && this.protocolClauseDto.itemCodeList.length > 0) {
        // 标的Code
        this.protocolClauseDto.itemNameList = [];
        this.protocolClauseDto.itemCodeList.forEach(function (item) {
          _this21.itemChildList.forEach(function (itemInfo) {
            if (item === itemInfo.codeCode) {
              _this21.protocolClauseDto.itemNameList.push(itemInfo.codeCname);
            }
          });
        });
        this.protocolClauseDto.itemName = this.protocolClauseDto.itemNameList.join(',');
        this.protocolClauseDto.itemCode = this.protocolClauseDto.itemCodeList.join(',');
      } // if (this.protocolClauseDto.itemNameList && this.protocolClauseDto.itemNameList.length > 0 ) {
      //   this.protocolClauseDto.itemName = this.protocolClauseDto.itemNameList.join(',')
      // } else {
      //   this.protocolClauseDto.itemName = ''
      // }


      if (this.protocolClauseDto.freightRateList && this.protocolClauseDto.freightRateList.length > 0) {
        this.protocolClauseDto.freightRateList.forEach(function (item) {
          if (item === '1') {
            if (_this21.protocolConveyintervalDto) {
              if (_this21.protocolConveyintervalDto.coStartContinentCodeList && _this21.protocolConveyintervalDto.coStartContinentCodeList.length > 0) {
                // 含启运地洲
                _this21.protocolConveyintervalDto.coStartContinentCode = _this21.protocolConveyintervalDto.coStartContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coStartCountryCodeList && _this21.protocolConveyintervalDto.coStartCountryCodeList.length > 0) {
                // 含启运地国家
                _this21.protocolConveyintervalDto.coStartCountryCode = _this21.protocolConveyintervalDto.coStartCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coStartCityCodeList && _this21.protocolConveyintervalDto.coStartCityCodeList.length > 0) {
                // 含启运地城市
                _this21.protocolConveyintervalDto.coStartCityCode = _this21.protocolConveyintervalDto.coStartCityCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exStartContinentCodeList && _this21.protocolConveyintervalDto.exStartContinentCodeList.length > 0) {
                // 除启运地洲
                _this21.protocolConveyintervalDto.exStartContinentCode = _this21.protocolConveyintervalDto.exStartContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exStartCountryCodeList && _this21.protocolConveyintervalDto.exStartCountryCodeList.length > 0) {
                // 除启运地国家
                _this21.protocolConveyintervalDto.exStartCountryCode = _this21.protocolConveyintervalDto.exStartCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exStartCityCodeList && _this21.protocolConveyintervalDto.exStartCityCodeList.length > 0) {
                // 除启运地城市
                _this21.protocolConveyintervalDto.exStartCityCode = _this21.protocolConveyintervalDto.exStartCityCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coViaContinentCodeList && _this21.protocolConveyintervalDto.coViaContinentCodeList.length > 0) {
                // 含中转地洲
                _this21.protocolConveyintervalDto.coViaContinentCode = _this21.protocolConveyintervalDto.coViaContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coViaCountryCodeList && _this21.protocolConveyintervalDto.coViaCountryCodeList.length > 0) {
                // 含中转地国家
                _this21.protocolConveyintervalDto.coViaCountryCode = _this21.protocolConveyintervalDto.coViaCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coViaCityCodeList && _this21.protocolConveyintervalDto.coViaCityCodeList.length > 0) {
                // 含中转地城市
                _this21.protocolConveyintervalDto.coViaCityCode = _this21.protocolConveyintervalDto.coViaCityCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exViaContinentCodeList && _this21.protocolConveyintervalDto.exViaContinentCodeList.length > 0) {
                // 除中转地洲
                _this21.protocolConveyintervalDto.exViaContinentCode = _this21.protocolConveyintervalDto.exViaContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exViaCountryCodeList && _this21.protocolConveyintervalDto.exViaCountryCodeList.length > 0) {
                // 除中转地国家
                _this21.protocolConveyintervalDto.exViaCountryCode = _this21.protocolConveyintervalDto.exViaCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exViaCityCodeList && _this21.protocolConveyintervalDto.exViaCityCodeList.length > 0) {
                // 除中转地城市
                _this21.protocolConveyintervalDto.exViaCityCode = _this21.protocolConveyintervalDto.exViaCityCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coEndContinentCodeList && _this21.protocolConveyintervalDto.coEndContinentCodeList.length > 0) {
                // 含目的地洲
                _this21.protocolConveyintervalDto.coEndContinentCode = _this21.protocolConveyintervalDto.coEndContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coEndCountryCodeList && _this21.protocolConveyintervalDto.coEndCountryCodeList.length > 0) {
                // 含目的地国家
                _this21.protocolConveyintervalDto.coEndCountryCode = _this21.protocolConveyintervalDto.coEndCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.coEndCityCodeList && _this21.protocolConveyintervalDto.coEndCityCodeList.length > 0) {
                // 含目的地城市
                _this21.protocolConveyintervalDto.coEndCityCode = _this21.protocolConveyintervalDto.coEndCityCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exEndContinentCodeList && _this21.protocolConveyintervalDto.exEndContinentCodeList.length > 0) {
                // 除目的地洲
                _this21.protocolConveyintervalDto.exEndContinentCode = _this21.protocolConveyintervalDto.exEndContinentCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exEndCountryCodeList && _this21.protocolConveyintervalDto.exEndCountryCodeList.length > 0) {
                // 除目的地国家
                _this21.protocolConveyintervalDto.exEndCountryCode = _this21.protocolConveyintervalDto.exEndCountryCodeList.join(',');
              }

              if (_this21.protocolConveyintervalDto.exEndCityCodeList && _this21.protocolConveyintervalDto.exEndCityCodeList.length > 0) {
                // 除目的地城市
                _this21.protocolConveyintervalDto.exEndCityCode = _this21.protocolConveyintervalDto.exEndCityCodeList.join(',');
              } // 启运地（含/除）中转地（含/除）目的地（含除） --只要洲有值就新建该对象
              // if (this.protocolConveyintervalDto.coStartContinentCode || this.protocolConveyintervalDto.exStartContinentCode ||
              //   this.protocolConveyintervalDto.coViaContinentCode || this.protocolConveyintervalDto.exViaContinentCode ||
              //   this.protocolConveyintervalDto.coEndContinentCode || this.protocolConveyintervalDto.exEndContinentCode) {


              _this21.protocolConveyintervalDto.insuranCecompanyCode = _this21.protoMageForm.protocolMainDto.insurancecompanyCode;
              _this21.protocolConveyintervalDto.insuranCecompanyName = _this21.protoMageForm.protocolMainDto.insurancecompanyName;
              _this21.protocolConveyintervalDto.protocolNo = _this21.protoMageForm.protocolMainDto.protocolNo;
              _this21.protocolConveyintervalDto.serialNo = _this21.protocolClauseDto.serialNo;
              _this21.protocolConveyintervalDto.riskCode = _this21.protocolRiskDto.riskCode;
              _this21.protocolConveyintervalDto.riskName = _this21.protocolRiskDto.riskName;
              _this21.protocolConveyintervalDto.clauseType = _this21.protocolClauseDto.clauseType;
              _this21.protocolConveyintervalDto.clauseName = _this21.protocolClauseDto.clauseName;
              _this21.protocolConveyintervalDto.clauseCode = _this21.protocolClauseDto.clauseCode;
              _this21.protocolConveyintervalDto.kindCode = _this21.protocolClauseDto.kindCode;
              _this21.protocolConveyintervalDto.kindName = _this21.protocolClauseDto.kindName;
              _this21.protocolConveyintervalDto.validationFlag = '1';
              _this21.protocolConveyintervalDto.flag = '2';
              _this21.protocolClauseDto.protocolConveyintervalDto = _this21.protocolConveyintervalDto; // 运输起-中-终
              // }
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择运输区间', '温馨提示');
            }
          } else if (item === '2') {
            if (!_this21.protocolClauseDto.isContainer || _this21.protocolClauseDto.isContainer === '') {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择是否集装箱', '温馨提示');
            }
          } else if (item === '3') {
            if (_this21.protocolClauseDto.isPackagList && _this21.protocolClauseDto.isPackagList.length > 0) {
              _this21.protocolClauseDto.isPackaging = _this21.protocolClauseDto.isPackagList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择包装方式', '温馨提示');
            }
          } else if (item === '4') {
            // 运输方式
            if (_this21.protocolClauseDto.conveyanceWayList && _this21.protocolClauseDto.conveyanceWayList.length > 0) {
              _this21.protocolClauseDto.conveyanceWay = _this21.protocolClauseDto.conveyanceWayList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择运输方式', '温馨提示');
            }
          } else if (item === '6') {
            // 申报基准
            if (_this21.protocolClauseDto.termsOfTradeList && _this21.protocolClauseDto.termsOfTradeList.length > 0) {
              _this21.protocolClauseDto.termsOfTrade = _this21.protocolClauseDto.termsOfTradeList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择申报基准', '温馨提示');
            }
          } else if (item === '7') {
            // 被保险人
            if (_this21.protocolClauseDto.theInsured && _this21.protocolClauseDto.theInsured.length > 0) {
              _this21.protocolClauseDto.theInsured = _this21.protocolClauseDto.theInsured.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('被保险人不能为空', '温馨提示');
            }
          }
        });
        this.protocolClauseDto.freightRateType = this.protocolClauseDto.freightRateList.join(',');
      } // clauseInfo = this.protocolClauseDto


      if (this.protocolClauseDto.clauseType === '2' && this.protocolAddrisksfactorDto.selectCondFlagList && this.protocolAddrisksfactorDto.selectCondFlagList.length > 0) {
        this.protocolAddrisksfactorDto.selectCondFlagList.forEach(function (item) {
          if (item === '1') {
            // 标的类型
            if (_this21.protocolAddrisksfactorDto.itemCodeList && _this21.protocolAddrisksfactorDto.itemCodeList.length > 0) {
              // 标的Code
              _this21.protocolAddrisksfactorDto.itemCode = _this21.protocolAddrisksfactorDto.itemCodeList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择标的类型', '温馨提示');
            }
          } else if (item === '2') {
            // 运输方式
            if (_this21.protocolAddrisksfactorDto.conveyanceWayList && _this21.protocolAddrisksfactorDto.conveyanceWayList.length > 0) {
              // 运输方式
              _this21.protocolAddrisksfactorDto.conveyanceWay = _this21.protocolAddrisksfactorDto.conveyanceWayList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择运输方式', '温馨提示');
            }
          } else if (item === '3') {
            if (!_this21.protocolAddrisksfactorDto.isRefrigeRate || _this21.protocolAddrisksfactorDto.isRefrigeRate === '') {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择是否冷藏', '温馨提示');
            }
          } else if (item === '4') {
            if (_this21.protocolAddrisksfactorDto.packgeList && _this21.protocolAddrisksfactorDto.packgeList.length > 0) {
              _this21.protocolAddrisksfactorDto.isPackagingNow = _this21.protocolAddrisksfactorDto.packgeList.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择包装', '温馨提示');
            }
          } else if (item === '5') {
            if (_this21.protocolAddrisksfactorDto.theInsured && _this21.protocolAddrisksfactorDto.theInsured.length > 0) {
              _this21.protocolAddrisksfactorDto.theInsured = _this21.protocolAddrisksfactorDto.theInsured.join(',');
            } else {
              checkClaseInfo = false;

              _this21.cofirmBox('请选择被保险人', '温馨提示');
            }
          }
        });
        this.protocolAddrisksfactorDto.selectCondFlag = this.protocolAddrisksfactorDto.selectCondFlagList.join(',');
        this.protocolAddrisksfactorDto.clauseCode = this.protocolClauseDto.clauseCode;
        this.protocolAddrisksfactorDto.clauseName = this.protocolClauseDto.clauseName;
        this.protocolAddrisksfactorDto.kindCode = this.protocolClauseDto.kindCode;
        this.protocolAddrisksfactorDto.kindName = this.protocolClauseDto.kindName;
        this.protocolClauseDto.protocolAddrisksfactorDto = this.protocolAddrisksfactorDto;
      }

      if (checkClaseInfo) {
        if (this.protocolClauseDto.state !== 'edit') {
          this.protocolClauseDtoList.push(this.protocolClauseDto);
        } else {
          this.protocolClauseDtoList[this.protocolClauseDto.indexInfo] = this.protocolClauseDto;
        } // console.log(this.protocolClauseDtoList)


        if (this.protocolClauseDto) {
          this.protocolClauseDto = {};
        }

        if (this.protocolAddrisksfactorDto) {
          this.protocolAddrisksfactorDto = {};
        }

        if (this.protocolConveyintervalDto) {
          this.protocolConveyintervalDto = {};
        }

        this.clauseInfoType = false;
      }
    },
    // 条则信息拆份

    /**
             * 拆份条则信息
             * @rowInfo 当前条款信息
             */
    itemInitialization: function itemInitialization(rowInfo) {
      this.protocolClauseDto = rowInfo; // 条款信息

      console.log('条款信息数据-查看/编辑时触发', this.protocolClauseDto); // if(this.protocolClauseDto.clauseType == '2'){
      //   this.isFlag = false
      //   console.log('1111')
      // }

      if (this.protocolClauseDto.protocolConveyintervalDto) {
        this.protocolConveyintervalDto = this.protocolClauseDto.protocolConveyintervalDto; // 运输区间
      } else {
        this.transSection = false;
        console.log('如果运输区间没值就不显示运输区间');
      }

      if (this.protocolClauseDto.protocolAddrisksfactorDto) {
        this.protocolAddrisksfactorDto = this.protocolClauseDto.protocolAddrisksfactorDto; // 附加险规则
      } else {
        console.log('无附加险规则', this.protocolClauseDto.protocolAddrisksfactorDto);
        this.protocolAddrisksfactorDto = {}; // 附加险规则
      }

      if (this.protocolClauseDto.itemCode) {
        // 除外货物标的Code
        this.protocolClauseDto.itemCodeList = this.protocolClauseDto.itemCode.split(','); // this.protocolClauseDto.itemCodeList.forEach(item => {
        //   this.protocolClauseDto.itemTypeList.push([item.substr(0, 2) + '00', item])
        // })
      }

      if (this.protocolClauseDto.freightRateType) {
        // 可选费率因子
        if (this.protocolClauseDto.freightRateList && this.protocolClauseDto.freightRateList.length > 0) {
          this.freightRateInitialization();
        } else {
          this.protocolClauseDto.freightRateList = this.protocolClauseDto.freightRateType.split(',');
          this.freightRateInitialization();
        }
      } else {
        this.protocolClauseDto.freightRateList = [];
        this.transSection = false;
        this.containerState = false;
        this.packingstate = false;
        this.transModeState = false;
        this.reportState = false;
        this.markupState = false;
        this.theInsuredState = false;
        console.log('申报基准是否触发11', this.reportState);
      }

      if (this.protocolClauseDto.clauseType === '2') {
        // 可选触发条件初始化
        if (this.protocolAddrisksfactorDto.selectCondFlag) {
          if (this.protocolAddrisksfactorDto.selectCondFlagList && this.protocolAddrisksfactorDto.selectCondFlagList.length > 0) {
            this.selectCondFlagInitialization();
          } else {
            this.protocolAddrisksfactorDto.selectCondFlagList = this.protocolAddrisksfactorDto.selectCondFlag.split(',');
            this.selectCondFlagInitialization();
          }
        } else {
          this.protocolAddrisksfactorDto.selectCondFlagList = [];
          this.triggerItemState = false;
          this.triggerTransModeState = false;
          this.triggerRefrigerateState = false;
          this.packState = false;
          this.theInsuredState3 = false; // if (this.triggerItemState === true) {
          //
          // }
          // if (this.triggerTransModeState === true) {
          // }
          // if (this.triggerRefrigerateState === true) {
          // }
          // if (this.packState === true) {
          // }
        }
      }
    },

    /**
             * 可选费率因子初始化
             */
    freightRateInitialization: function freightRateInitialization() {
      var _this22 = this;

      this.transSection = false;
      this.containerState = false;
      this.packingstate = false;
      this.transModeState = false;
      this.reportState = false;
      this.markupState = false;
      this.theInsuredState = false; // if (this.transSection === true) {
      //   this.transSection = false
      // }
      // if (this.containerState === true) {
      //   this.containerState = false
      // }
      // if (this.packingstate === true) {
      //   this.packingstate = false
      // }
      // if (this.transModeState === true) {
      //   this.transModeState = false
      // }
      // if (this.reportState === true) {
      //   this.reportState = false
      // }
      // if (this.markupState === true) {
      //   this.markupState = false
      // }

      console.log('勾选的数组', this.protocolClauseDto.freightRateList);
      this.protocolClauseDto.freightRateList.forEach(function (item) {
        console.log('item', item);

        if (item === '1') {
          _this22.transSection = true;
          console.log('含启运地的生产：', _this22.protocolConveyintervalDto.coStartCityCode);

          if (_this22.protocolConveyintervalDto.coStartContinentCode) {
            // 含启运地洲
            _this22.protocolConveyintervalDto.coStartContinentCodeList = _this22.protocolConveyintervalDto.coStartContinentCode.split(','); // this.clauseCoCountryList = getUnderCountry(this.protocolConveyintervalDto.coStartContinentCodeList)
          }

          if (_this22.protocolConveyintervalDto.coStartCountryCode) {
            // 含启运地国家
            _this22.protocolConveyintervalDto.coStartCountryCodeList = _this22.protocolConveyintervalDto.coStartCountryCode.split(','); //  this.clauseCoCityList = getUnderCity(this.protocolConveyintervalDto.coStartCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.coStartCityCode) {
            // 含启运地城市
            _this22.protocolConveyintervalDto.coStartCityCodeList = _this22.protocolConveyintervalDto.coStartCityCode.split(',');
          }

          if (_this22.protocolConveyintervalDto.exStartContinentCode) {
            // 除启运地洲
            _this22.protocolConveyintervalDto.exStartContinentCodeList = _this22.protocolConveyintervalDto.exStartContinentCode.split(','); // this.clauseExCountryList = getUnderCountry(this.protocolConveyintervalDto.exStartContinentCodeList)
          }

          if (_this22.protocolConveyintervalDto.exStartCountryCode) {
            // 除启运地国家
            _this22.protocolConveyintervalDto.exStartCountryCodeList = _this22.protocolConveyintervalDto.exStartCountryCode.split(','); // this.clauseExCityList = getUnderCity(this.protocolConveyintervalDto.exStartCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.exStartCityCode) {
            // 除启运地城市
            _this22.protocolConveyintervalDto.exStartCityCodeList = _this22.protocolConveyintervalDto.exStartCityCode.split(',');
          }

          if (_this22.protocolConveyintervalDto.coViaContinentCode) {
            // 含中转地洲
            _this22.protocolConveyintervalDto.coViaContinentCodeList = _this22.protocolConveyintervalDto.coViaContinentCode.split(','); // this.clauseCoViaCountryList = getUnderCountry(this.protocolConveyintervalDto.coViaContinentCodeList)
          }

          if (_this22.protocolConveyintervalDto.coViaCountryCode) {
            // 含中转地国家
            _this22.protocolConveyintervalDto.coViaCountryCodeList = _this22.protocolConveyintervalDto.coViaCountryCode.split(','); // this.clauseCoViaCityList = getUnderCity(this.protocolConveyintervalDto.coViaCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.coViaCityCode) {
            // 含中转地城市
            _this22.protocolConveyintervalDto.coViaCityCodeList = _this22.protocolConveyintervalDto.coViaCityCode.split(',');
          }

          if (_this22.protocolConveyintervalDto.exViaContinentCode) {
            // 除中转地洲
            _this22.protocolConveyintervalDto.exViaContinentCodeList = _this22.protocolConveyintervalDto.exViaContinentCode.split(','); // this.clauseExViaCountryList = getUnderCountry(this.protocolConveyintervalDto.exViaContinentCodeList)
          }

          if (_this22.riskConveyintervalDto.exViaCountryCode) {
            // 除中转地国家
            _this22.riskConveyintervalDto.exViaCountryCodeList = _this22.riskConveyintervalDto.exViaCountryCode.split(','); // this.clauseExViaCityList = getUnderCity(this.protocolConveyintervalDto.exViaCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.exViaCityCode) {
            // 除中转地城市
            _this22.protocolConveyintervalDto.exViaCityCodeList = _this22.protocolConveyintervalDto.exViaCityCode.split(',');
          }

          if (_this22.protocolConveyintervalDto.coEndContinentCode) {
            // 含目的地洲
            _this22.protocolConveyintervalDto.coEndContinentCodeList = _this22.protocolConveyintervalDto.coEndContinentCode.split(','); // this.clauseCoEndCountryList = getUnderCountry(this.protocolConveyintervalDto.coEndContinentCodeList)
          }

          if (_this22.protocolConveyintervalDto.coEndCountryCode) {
            // 含目的地国家
            _this22.protocolConveyintervalDto.coEndCountryCodeList = _this22.protocolConveyintervalDto.coEndCountryCode.split(','); // this.clauseCoEndCityList = getUnderCity(this.protocolConveyintervalDto.coEndCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.coEndCityCode) {
            // 含目的地城市
            _this22.protocolConveyintervalDto.coEndCityCodeList = _this22.protocolConveyintervalDto.coEndCityCode.split(',');
          }

          if (_this22.protocolConveyintervalDto.exEndContinentCode) {
            // 除目的地洲
            _this22.protocolConveyintervalDto.exEndContinentCodeList = _this22.protocolConveyintervalDto.exEndContinentCode.split(','); // this.clauseExEndCountryList = getUnderCountry(this.protocolConveyintervalDto.exEndContinentCodeList)
          }

          if (_this22.protocolConveyintervalDto.exEndCountryCode) {
            // 除目的地国家
            _this22.protocolConveyintervalDto.exEndCountryCodeList = _this22.protocolConveyintervalDto.exEndCountryCode.split(','); // this.clauseExEndCityList = getUnderCity(this.protocolConveyintervalDto.exEndCountryCodeList)
          }

          if (_this22.protocolConveyintervalDto.exEndCityCode) {
            // 除目的地城市
            _this22.protocolConveyintervalDto.exEndCityCodeList = _this22.protocolConveyintervalDto.exEndCityCode.split(',');
          }
        } else if (item === '2') {
          console.log('是否勾选集装箱', _this22.containerState);
          _this22.containerState = true;
        } else if (item === '3') {
          console.log('是否勾选了包装', _this22.protocolClauseDto.isPackaging);

          if (_this22.protocolClauseDto.isPackaging) {
            // 包装
            _this22.protocolClauseDto.isPackagList = _this22.protocolClauseDto.isPackaging.split(',');
          }

          _this22.packingstate = true;
        } else if (item === '4') {
          console.log('是否勾选运输方式', _this22.protocolClauseDto.conveyanceWay);

          if (_this22.protocolClauseDto.conveyanceWay) {
            // 运输方式
            _this22.protocolClauseDto.conveyanceWayList = _this22.protocolClauseDto.conveyanceWay.split(',');
          }

          _this22.transModeState = true;
        } else if (item === '6') {
          console.log('是否勾选了申报基准', _this22.protocolClauseDto.termsOfTrade);

          if (_this22.protocolClauseDto.termsOfTrade) {
            // 申报基准
            _this22.protocolClauseDto.termsOfTradeList = _this22.protocolClauseDto.termsOfTrade.split(',');
          }

          _this22.reportState = true;
        } else if (item === '5') {
          console.log('是否勾选了特殊加成比例', _this22.markupState);
          _this22.markupState = true;
        } else if (item === '7') {
          //console.log('是否勾选了被保险人',this.theInsuredState)
          if (_this22.protocolClauseDto.theInsured) {
            // 被保险人
            _this22.protocolClauseDto.theInsured = _this22.protocolClauseDto.theInsured.split(',');
          }

          _this22.theInsuredState = true;
        }
      });
    },

    /**
             * 可选触发条件初始化
             */
    selectCondFlagInitialization: function selectCondFlagInitialization() {
      var _this23 = this;

      if (this.triggerItemState === true) {
        this.triggerItemState = false;
      }

      if (this.triggerTransModeState === true) {
        this.triggerTransModeState = false;
      }

      if (this.triggerRefrigerateState === true) {
        this.triggerRefrigerateState = false;
      }

      if (this.packState === true) {
        this.packState = false;
      }

      if (this.theInsuredState3 === true) {
        this.theInsuredState3 = false;
      }

      this.protocolAddrisksfactorDto.selectCondFlagList.forEach(function (item) {
        if (item === '1') {
          // 标的类型
          if (_this23.protocolAddrisksfactorDto.itemCode) {
            // 条件触发附加险标的Code
            // this.protocolAddrisksfactorDto.itemTypeList = []
            _this23.protocolAddrisksfactorDto.itemCodeList = _this23.protocolAddrisksfactorDto.itemCode.split(','); // this.protocolAddrisksfactorDto.itemCodeList.forEach(item => {
            //   this.protocolAddrisksfactorDto.itemTypeList.push([item.substr(0, 2) + '00', item])
            // })
          }

          _this23.triggerItemState = true;
        } else if (item === '2') {
          // 运输方式
          if (_this23.protocolAddrisksfactorDto.conveyanceWay) {
            // 运输方式
            if (!_this23.protocolAddrisksfactorDto.conveyanceWayList) {
              _this23.protocolAddrisksfactorDto.conveyanceWayList = _this23.protocolAddrisksfactorDto.conveyanceWay.split(',');
            }
          }

          _this23.triggerTransModeState = true;
        } else if (item === '3') {
          // 是否冷藏
          _this23.triggerRefrigerateState = true;
        } else if (item === '4') {
          // 有无包装
          if (_this23.protocolAddrisksfactorDto.isPackagingNow) {
            _this23.protocolAddrisksfactorDto.packgeList = _this23.protocolAddrisksfactorDto.isPackagingNow.split(',');
          }

          _this23.packState = true;
        } else if (item === '5') {
          // 有无被保险人
          if (_typeof(_this23.protocolAddrisksfactorDto.theInsured) == 'object') {
            _this23.protocolAddrisksfactorDto.theInsured = _this23.protocolAddrisksfactorDto.theInsured.join(',');
          }

          if (_this23.protocolAddrisksfactorDto.theInsured) {
            _this23.protocolAddrisksfactorDto.theInsured = _this23.protocolAddrisksfactorDto.theInsured.split(',');
          }

          _this23.theInsuredState3 = true;
        }
      });
    },

    /**
             * 保额保费限制条件新增
             */
    addPremium: function addPremium() {
      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称！', '温馨提示');
      } else {
        var length = this.protocolAmountDtoList.length;
        this.itemPremium = false;
        this.transPremium = false;
        this.theInsuredState2 = false;
        this.transSectionBEBF = false;
        this.protocolAmountDto = {
          protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
          serialNo: length === 0 ? '1' : (parseInt(this.protocolAmountDtoList[length - 1].serialNo) + 1).toString(),
          insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
          insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
          riskCode: this.protocolRiskDto.riskCode,
          riskName: this.protocolRiskDto.riskName,
          influenceType: '',
          influenceList: [],
          conveyanceWayList: [],
          conveyanceWayNameList: [],
          conveyanceWay: '',
          conveyanceWayName: '',
          packTypeLitst: [],
          itemCodeList: [],
          itemNameList: [],
          itemCode: '',
          itemName: '',
          currency: 'CNY',
          tallSinglePassQuota: '0.00',
          lowSinglePassQuota: '0.00',
          state: '',
          validationFlag: '1',
          theInsured: '',

          /*运输区间*/

          /*含起运地城市代码*/
          coStartCityCode: '',

          /*除起运地城市代码*/
          exStartCityCode: '',

          /*含中转地城市代码*/
          coViaCityCode: '',

          /*除中转地城市代码*/
          exViaCityCode: '',

          /*含目的地城市代码*/
          coEndCityCode: '',

          /*除目的地城市代码*/
          exEndCityCode: ''
        };
        this.protocoPremiumState = false;
        this.premiumType = true;
      }
    },

    /**
             * 可选影响因子选择
             * @$event
             */
    checkedPremium: function checkedPremium($event, item) {
      if (item === '1') {
        if ($event) {
          this.transPremium = true;
        } else {
          this.transPremium = false;
          this.protocolAmountDto.conveyanceWayList = [];
          this.protocolAmountDto.conveyanceWay = '';
          this.protocolAmountDto.conveyanceWayNameList = [];
          this.protocolAmountDto.conveyanceWayName = '';
        }
      } else if (item === '2') {
        if ($event) {
          this.itemPremium = true;
        } else {
          this.itemPremium = false;
          this.protocolAmountDto.itemCodeList = [];
          this.protocolAmountDto.itemCode = '';
          this.protocolAmountDto.itemNameList = [];
          this.protocolAmountDto.itemName = '';
        }
      } else if (item == '3') {
        this.theInsuredList2 = [];

        if ($event) {
          this.theInsuredState2 = true;
          this.putTheInsureList2();
        } else {
          this.theInsuredState2 = false;
          this.protocolAmountDto.theInsured = '';
        }
      } else if (item == '4') {
        //new 运输区间
        if ($event) {
          this.transSectionBEBF = true;
        } else {
          this.transSectionBEBF = false;
        }
      }
    },
    //拷贝基本信息里的被保险人
    putTheInsureList2: function putTheInsureList2() {
      var _this24 = this;

      this.theInsuredList2 = [];
      this.protocolInsuredDtoList.forEach(function (ele, index) {
        if (ele.insuredName && ele.idEntifyTypeCode && ele.identifyNumber && ele.address) {
          _this24.theInsuredList2.push({
            codeName: ele.insuredName,
            codeCode: ele.identifyNumber
          });
        }
      });
    },
    checkedprotocol: function checkedprotocol($event, item) {
      if (item === '1') {
        if ($event) {
          this.conveyPremium = true;
        } else {
          this.conveyPremium = false;
          this.protocolEngageDto.conveyanceWay = '';
          this.protocolEngageDto.conveyanceWayName = '';
          this.protocolEngageDto.conveyanceWayList = [];
        }
      } else if (item === '2') {
        if ($event) {
          this.itemCodePremium = true;
        } else {
          this.itemCodePremium = false;
          this.protocolEngageDto.itemName = '';
          this.protocolEngageDto.itemCode = '';
          this.protocolEngageDto.itemCodeList = [];
        }
      } else if (item === '3') {
        if ($event) {
          this.protocolSection = true;
        } else {
          this.protocolSection = false;
        }
      }

      console.log(this.protocolEngageDto.conveyanceWay, this.protocolEngageDto.conveyanceWayList);
    },

    /**
             * 保额保费限制条件保存
             */
    savePremium: function savePremium() {
      var _this25 = this;

      var checkState = true;

      if ((!this.protocolAmountDto.tallSinglePassQuota || this.protocolAmountDto.tallSinglePassQuota === '' || this.protocolAmountDto.tallSinglePassQuota === '0.00') && (!this.protocolAmountDto.lowSinglePassQuota || this.protocolAmountDto.lowSinglePassQuota === '' || this.protocolAmountDto.lowSinglePassQuota === '0.00')) {
        this.cofirmBox('最高保额和最低保费不能同时为空！', '温馨提示');
      } else {
        if (this.protocolAmountDto.influenceList.length > 0) {
          // 可选影响因子
          this.protocolAmountDto.influenceList.forEach(function (item) {
            if (item === '1') {
              if (_this25.protocolAmountDto.conveyanceWayList.length > 0) {
                // 运输方式
                _this25.protocolAmountDto.conveyanceWayNameList = [];

                _this25.protocolAmountDto.conveyanceWayList.forEach(function (item) {
                  _this25.conveyanceList.forEach(function (itemInfo) {
                    if (itemInfo.codeCode == item) {
                      _this25.protocolAmountDto.conveyanceWayNameList.push(itemInfo.codeCname);
                    }
                  });
                });

                _this25.protocolAmountDto.conveyanceWayName = _this25.protocolAmountDto.conveyanceWayNameList.join(',');
                _this25.protocolAmountDto.conveyanceWay = _this25.protocolAmountDto.conveyanceWayList.join(',');
              } else {
                checkState = false;

                _this25.cofirmBox('运输方式不能为空！', '温馨提示');
              }
            } else if (item === '2') {
              if (_this25.protocolAmountDto.itemCodeList.length > 0) {
                // 标的类型
                _this25.protocolAmountDto.itemNameList = [];

                _this25.protocolAmountDto.itemCodeList.forEach(function (item) {
                  _this25.itemChildList.forEach(function (itemInfo) {
                    if (itemInfo.codeCode == item) {
                      _this25.protocolAmountDto.itemNameList.push(itemInfo.codeCname);
                    }
                  });
                });

                _this25.protocolAmountDto.itemName = _this25.protocolAmountDto.itemNameList.join(',');
                _this25.protocolAmountDto.itemCode = _this25.protocolAmountDto.itemCodeList.join(',');
              } else {
                checkState = false;

                _this25.cofirmBox('标的类型不能为空！', '温馨提示');
              }
            } else if (item == '3') {
              if (checkState) {
                if (_this25.protocolAmountDto.theInsured && _this25.protocolAmountDto.theInsured.length > 0) {
                  _this25.protocolAmountDto.theInsured = _this25.protocolAmountDto.theInsured.join(',');
                } else {
                  checkState = false;

                  _this25.cofirmBox('被保险人不能为空', '温馨提示');
                }
              }
            }
          });
          this.protocolAmountDto.influenceType = this.protocolAmountDto.influenceList.join(',');
        }

        if (checkState) {
          if (this.protocolAmountDto.state === 'edit') {
            this.protocolAmountDtoList[parseInt(this.protocolAmountDto.serialNo) - 1] = this.protocolAmountDto;
          } else {
            this.protocolAmountDtoList.push(this.protocolAmountDto);
          }

          this.premiumType = false;

          if (this.protocolAmountDto) {
            this.protocolAmountDto = {};
          }
        }
      }
    },

    /**
             * 保额保费限制条件取消
             */
    closePremium: function closePremium() {
      if (this.protocolAmountDto) {
        this.protocolAmountDto = {};
      }

      this.premiumType = false;
    },

    /**
             * 查看和修改保额保费限制条件
             */
    updateAndViewPremium: function updateAndViewPremium(type, row) {
      var _this26 = this;

      ////debugger;;;
      this.protocolAmountDto = Object.assign({
        state: ''
      }, row);

      if (this.transPremium === true) {
        this.transPremium = false;
      }

      if (this.itemPremium === true) {
        this.itemPremium = false;
      }

      if (this.theInsuredState2 === true) {
        this.theInsuredState2 = false;
      }

      if (this.transSectionBEBF === true) {
        this.transSectionBEBF = false;
      }

      if (this.protocolAmountDto.currency && this.protocolAmountDto.currency === 'JPY') {
        this.decimalValue = 0;
      } else {
        this.decimalValue = 2;
      }

      if (this.protocolAmountDto.influenceType) {
        // 可选影响因子
        if (this.protocolAmountDto.influenceList) {
          this.protocolAmountDto.influenceList.forEach(function (item) {
            if (item == '1') {
              _this26.transPremium = true;
            } else if (item == '2') {
              _this26.itemPremium = true;
            } else if (item == '3') {
              _this26.theInsuredState2 = true;
            } else if (item == '4') {
              _this26.transSectionBEBF = true;
            }
          });
        } else {
          this.protocolAmountDto.influenceList = row.influenceType.split(',');
          this.protocolAmountDto.influenceList.forEach(function (item) {
            if (item == '1') {
              _this26.transPremium = true;
            } else if (item == '2') {
              _this26.itemPremium = true;
            } else if (item == '3') {
              _this26.theInsuredState2 = true;
            } else if (item == '4') {
              _this26.transSectionBEBF = true;
            }
          });
        }
      } else {
        this.protocolAmountDto.influenceList = [];
      }

      if (this.protocolAmountDto.conveyanceWay) {
        // 运输方式
        if (!this.protocolAmountDto.conveyanceWayList) {
          this.protocolAmountDto.conveyanceWayList = this.protocolAmountDto.conveyanceWay.split(',');
        }
      }

      if (this.protocolAmountDto.itemCode) {
        // 标的
        if (!this.protocolAmountDto.itemCodeList) {
          this.protocolAmountDto.itemCodeList = this.protocolAmountDto.itemCode.split(',');
        }
      }

      if (this.protocolAmountDto.theInsured) {
        // 被保险人
        this.protocolAmountDto.theInsured = this.protocolAmountDto.theInsured.split(',');
      } // 运输区间


      if (this.protocolAmountDto.coStartCityCode) {
        // 含启运地城市
        this.protocolConveyintervalDto3.coStartCityCodeList = this.protocolAmountDto.coStartCityCode.split(',');
      }

      if (this.protocolAmountDto.exStartCityCode) {
        //除启运地城市
        this.protocolConveyintervalDto3.exStartCityCodeList = this.protocolAmountDto.exStartCityCode.split(',');
      }

      if (this.protocolAmountDto.coViaCityCode) {
        //含中转地城市
        this.protocolConveyintervalDto3.coViaCityCodeList = this.protocolAmountDto.coViaCityCode.split(',');
      }

      if (this.protocolAmountDto.exViaCityCode) {
        //除中转地城市
        this.protocolConveyintervalDto3.exViaCityCodeList = this.protocolAmountDto.exViaCityCode.split(',');
      }

      if (this.protocolAmountDto.coEndCityCode) {
        //含目的地城市
        this.protocolConveyintervalDto3.coEndCityCodeList = this.protocolAmountDto.coEndCityCode.split(',');
      }

      if (this.protocolAmountDto.exEndCityCode) {
        //除目的地城市
        this.protocolConveyintervalDto3.exEndCityCodeList = this.protocolAmountDto.exEndCityCode.split(',');
      }

      console.log('运输区间复制后', this.protocolConveyintervalDto3);

      if (type === 'view') {
        this.protocoPremiumState = true;
      } else {
        this.protocoPremiumState = false;
        this.protocolAmountDto.state = 'edit';
      }

      this.premiumType = true;
    },

    /**
             * 删除保额保费限制条件
             * @ row 当前对象
             */
    deletePremium: function deletePremium(row) {
      var _this27 = this;

      this.$confirm('是否要删除该保额保费限制条件信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        row.validationFlag = '0';

        _this27.$forceUpdate();
      });
    },

    /**
             * 币种变换导致金额调整
             * @ val 币种类型
             */
    currencyChange: function currencyChange(val) {
      console.log(val); // this.symbolVal = val

      if (val === 'JPY') {
        this.decimalValue = 0;
      } else {
        this.decimalValue = 2;
      }
    },

    /**
             * 船龄加费新增
             */
    addAgePlus: function addAgePlus() {
      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称！', '温馨提示');
      } else {
        var length = this.protocolShipageDtoList.length;
        this.protocolShipageDtoList.push({
          protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
          serialNo: length === 0 ? '1' : (parseInt(this.protocolShipageDtoList[length - 1].serialNo) + 1).toString(),
          insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
          insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
          riskCode: this.protocolRiskDto.riskCode,
          riskName: this.protocolRiskDto.riskName,
          beginShipAge: '',
          endShipAge: '',
          addFeeRate: '',
          validationFlag: '1',
          action: true
        });
      }
    },

    /**
             * 多条船龄区间不能重合
             * @ Info 当前船龄起始时间
             */
    checkBginShipAge: function checkBginShipAge(indexInfo, Info) {
      var shipInfoList = []; // console.log(indexInfo)

      shipInfoList = this.protocolShipageDtoList.filter(function (data) {
        return data.validationFlag === '1';
      });
      var length = this.protocolShipageDtoList.length;

      if (shipInfoList.length > 1) {
        if (shipInfoList[length - 2].endShipAge > Info.beginShipAge) {
          Info.beginShipAge = '';
          this.$message({
            type: 'warning',
            message: '船龄区间不能重叠'
          });
        }
      } // console.log(Info)

    },

    /**
             * 起始船龄应小于终止船龄
             * @ indexInfo 小标
             * @ Info 当前船龄区间对象
             */
    checkEndShipAge: function checkEndShipAge(indexInfo, Info) {
      if (Info.beginShipAge && Info.endShipAge && Number(Info.beginShipAge) > Number(Info.endShipAge)) {
        Info.endShipAge = '';
        this.$message({
          type: 'warning',
          message: '起始船龄应小于终止船龄'
        });
      }
    },

    /**
             * 删除船龄加费
             * @ row 船龄加费对象
             */
    deleteAgePlus: function deleteAgePlus(row) {
      var _this28 = this;

      this.$confirm('是否要删除该船龄加费信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        row.validationFlag = '0';

        _this28.$forceUpdate();
      });
    },

    /**
             * 新增特别约定
             */
    addEngageInfo: function addEngageInfo() {
      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称！', '温馨提示');
      } else {
        var length = this.protocolEngageDtoList.length;
        this.protocolEngageDto = {
          protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
          serialNo: length === 0 ? '1' : (parseInt(this.protocolEngageDtoList[length - 1].serialNo) + 1).toString(),
          insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
          insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
          riskCode: this.protocolRiskDto.riskCode,
          riskName: this.protocolRiskDto.riskName,
          engAgeCode: '',
          engAgeName: '',
          engAgecontent: '',
          state: '',
          validationFlag: '1'
        };
        this.engageType = true;
        this.protocolEngageState = false;
      }
    },

    /**
             * 保存特约
             */
    saveEngage: function saveEngage() {
      var _this29 = this;

      if (!this.protocolEngageDto.engAgeCode || this.protocolEngageDto.engAgeCode === '') {
        this.cofirmBox('请选择特约信息！', '温馨提示');
      } else {
        var engageInfo = [];
        var protocolEngagList = this.protocolEngageDtoList.filter(function (data) {
          return data.validationFlag === '1';
        });
        protocolEngagList.forEach(function (item) {
          if (_this29.protocolEngageDto.engAgeCode === item.engAgeCode) {
            engageInfo.push(item);
          }
        });

        if (engageInfo.length > 0) {
          this.protocolEngageDto.engAgeCode = '';
          this.protocolEngageDto.engAgeName = '';
          this.protocolEngageDto.engAgecontent = '';
          this.$message({
            type: 'warning',
            message: '该特约信息已存在，请重新选择'
          });
        } else {
          if (this.protocolEngageDto.state === 'edit') {
            this.protocolEngageDtoList[parseInt(this.protocolEngageDto.serialNo) - 1] = this.protocolEngageDto;
          } else {
            this.protocolEngageDtoList.push(this.protocolEngageDto);
          }

          this.engageType = false;
        }
      }

      if (this.protocolEngageDto) {
        this.protocolEngageDto = {};
      }
    },

    /**
             * 关闭特约
             */
    closeEngage: function closeEngage() {
      if (this.protocolEngageDto) {
        this.protocolEngageDto = {};
      }

      this.engageType = false;
    },

    /**
             * 获取特约名称与内容
             */
    getEngageName: function getEngageName(e) {
      var _this30 = this;

      var codeCode = e;
      this.engageList.forEach(function (item) {
        if (codeCode == item.engageCode) {
          _this30.protocolEngageDto.engAgeCod = item.engageCode;
          _this30.protocolEngageDto.engAgeName = item.engageName;
          _this30.protocolEngageDto.engAgecontent = item.engageContent;
        }
      });
    },

    /**
             * 修改与浏览特约内容
             * @type 类型
             * @ row 特约内容
             */
    updateAndViewEngage: function updateAndViewEngage(type, row) {
      this.conveyPremium = false;
      this.itemCodePremium = false;
      this.protocolSection = false;
      this.protocolEngageDto = Object.assign({
        state: ''
      }, row);

      if (this.protocolEngageDto.protocolConveyintervalDto) {
        this.protocolConveyintervalDto2 = this.protocolEngageDto.protocolConveyintervalDto;
      }

      if (type === 'view') {
        this.protocolEngageState = true;
      } else {
        this.protocolEngageState = false;
        this.protocolEngageDto.state = 'edit';
      }

      this.engageType = true;

      if (this.protocolEngageDto.conveyanceWay) {
        this.conveyPremium = true;
        this.protocolEngageDto.conveyanceWayList = this.protocolEngageDto.conveyanceWay.split(',');
      }

      if (this.protocolEngageDto.itemCode) {
        this.itemCodePremium = true;
        this.protocolEngageDto.itemCodeList = this.protocolEngageDto.itemCode.split(',');
      }

      if (this.protocolEngageDto.influenceType) {
        this.protocolEngageDto.influenceTypeList = this.protocolEngageDto.influenceType.split(',');
      }

      if (this.protocolEngageDto.influenceType && this.protocolEngageDto.influenceType.indexOf('3') > -1) {
        this.protocolSection = true;

        if (this.protocolConveyintervalDto2.coStartCityCode) {
          // 含启运地城市
          this.protocolConveyintervalDto2.coStartCityCodeList = this.protocolConveyintervalDto2.coStartCityCode.split(',');
        }

        if (this.protocolConveyintervalDto2.exStartCityCode) {
          //除启运地城市
          this.protocolConveyintervalDto2.exStartCityCodeList = this.protocolConveyintervalDto2.exStartCityCode.split(',');
        }

        if (this.protocolConveyintervalDto2.coViaCityCode) {
          //含中转地城市
          this.protocolConveyintervalDto2.coViaCityCodeList = this.protocolConveyintervalDto2.coViaCityCode.split(',');
        }

        if (this.protocolConveyintervalDto2.exViaCityCode) {
          //除中转地城市
          this.protocolConveyintervalDto2.exViaCityCodeList = this.protocolConveyintervalDto2.exViaCityCode.split(',');
        }

        if (this.protocolConveyintervalDto2.coEndCityCode) {
          //含目的地城市
          this.protocolConveyintervalDto2.coEndCityCodeList = this.protocolConveyintervalDto2.coEndCityCode.split(',');
        }

        if (this.protocolConveyintervalDto2.exEndCityCode) {
          //除目的地城市
          this.protocolConveyintervalDto2.exEndCityCodeList = this.protocolConveyintervalDto2.exEndCityCode.split(',');
        }
      }
    },

    /**
             * 删除特约
             * @ row 特约内容
             */
    deleteEngage: function deleteEngage(row) {
      var _this31 = this;

      this.$confirm('是否要删除该特约内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        row.validationFlag = '0';

        _this31.$forceUpdate();
      });
    },

    /**
             * 全单限额/免赔新增
             */
    addLimitlInfo: function addLimitlInfo() {
      var limitInfoList = this.protocolLimitDtoList.filter(function (data) {
        return data.validationFlag === '1';
      });
      var lengthInfo = limitInfoList.length;

      if (!this.protocolRiskDto.riskCode || this.protocolRiskDto.riskCode === '') {
        this.cofirmBox('请选择产品名称！', '温馨提示');
      } else if (lengthInfo > 0 && (!limitInfoList[lengthInfo - 1].limitNo || limitInfoList[lengthInfo - 1].limitNo === '' || !limitInfoList[lengthInfo - 1].limitCondit || limitInfoList[lengthInfo - 1].limitCondit === '')) {
        this.cofirmBox('请完善免赔信息！', '温馨提示');
      } else {
        var length = this.protocolLimitDtoList.length;
        this.protocolLimitDtoList.push({
          protocolNo: this.protoMageForm.protocolMainDto.protocolNo,
          serialNo: length === 0 ? '1' : (parseInt(this.protocolLimitDtoList[length - 1].serialNo) + 1).toString(),
          insuranCecompanyCode: this.protoMageForm.protocolMainDto.insurancecompanyCode,
          insuranCecompanyName: this.protoMageForm.protocolMainDto.insurancecompanyName,
          riskCode: this.protocolRiskDto.riskCode,
          riskName: this.protocolRiskDto.riskName,
          limitNo: '',
          limitType: '',
          limitCondit: '',
          currency: '',
          remark: '',
          validationFlag: '1',
          action: true
        });
      }
    },

    /**
             * 全单限额/免赔删除
             * @row 当前行信息
             */
    deleteLimitlInfo: function deleteLimitlInfo(row) {
      var _this32 = this;

      this.$confirm('是否要删除该免赔内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        row.validationFlag = '0';

        _this32.$forceUpdate();
      });
    },

    /**
             * 全单限额/免赔信息获取
             * @ e当前选中信息
             * @row 当前行信息
             */
    getLimitlInfoName: function getLimitlInfoName(e, row) {
      // console.log(row)
      // console.log(this.$refs)
      // row.limitType = e
      // console.log(this.$refs.limitSearch.hoverOption.currentLabel)
      var limitInfoList = this.protocolLimitDtoList.filter(function (data) {
        return data.validationFlag === '1';
      });
      var postInfo = [];
      limitInfoList.forEach(function (item) {
        if (e === item.limitNo) {
          postInfo.push(item);
        }
      });

      if (postInfo.length > 1) {
        row.limitNo = '';
        this.$message({
          type: 'warning',
          message: '该免赔已存在，请重新选择'
        });
      } else {
        this.limitOptions.forEach(function (item) {
          if (e === item.limitCode) {
            row.limitType = item.limitName;
            row.viewType = item.viewType;
          }
        });
      }
    },
    checkLimitCondit: function checkLimitCondit(index, Info) {// const checkType = Info.limitType.charAt(Info.limitType.length - 1)
      // if (checkType === '率' && (Info.limitCondit > 100 || Info.limitCondit < 0)) {
      //   this.cofirmBox(Info.limitType + '应大于 0小于100', '温馨提示')
      // }
    },
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    textbox: function textbox(e) {// console.log(e)
    },

    /**
             * 协议取消
             */
    cancelProtoInfo: function cancelProtoInfo() {
      // this.$router.replace({ name: 'protocoSearch' })
      // 返回上一步路由
      this.$router.go(-1); // 关闭导航栏

      this.$store.dispatch('delVisitedViews', this.$route);
    },

    /**
             * 协议提交
             * @type  提交类型
             */
    submitProtoInfo: function submitProtoInfo(type) {
      var _this33 = this;

      // 协议提交时判断协议产品数据录入是否大于一条就可以
      var submitFlag = true;
      this.loading = true;
      var submitType = '1';

      if (type === '0') {
        submitType = '0';
        this.protoMageForm.protocolMainDto.protocolStatus = '03';
      } else {
        this.protoMageForm.protocolMainDto.protocolStatus = '04';

        if (this.protocolRiskDtoList && this.protocolRiskDtoList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请录入协议产品信息'
          });
          this.loading = false;
          submitType = '1';
          submitFlag = false;
        }
      } // console.log(this.protoMageForm.protocolMainDto) // 基本信息
      // console.log(this.protoMageForm.protocolApplicantDto) // 投保人信息
      // console.log(this.protocolInsuredDtoList) // 被保险人集合信息
      // console.log(this.protocolCoinsDtoList) // 联共保集合信息
      // console.log(this.protocolRiskDtoList) // 条则集合信息


      if (submitFlag) {
        this.protocolInsuredDtoList.forEach(function (item) {
          item.isUpdateInsuredName = _this33.protocolInsuredDtoList[0].isUpdateInsuredName;
          item.validationFlag = '1';
        });
        this.protoMageForm.protocolMainDto.validationFlag = '1';
        this.protoMageForm.protocolApplicantDto.validationFlag = '1';

        if (this.protocolCoinsDtoList && this.protocolCoinsDtoList.length > 0) {
          this.protocolCoinsDtoList.forEach(function (item) {
            item.validationFlag = '1';
          });
        }

        var para = {
          'submitType': submitType,
          'protocolMainDto': this.protoMageForm.protocolMainDto,
          'protocolApplicantDto': this.protoMageForm.protocolApplicantDto,
          'protocolInsuredDtoList': this.protocolInsuredDtoList,
          'protocolCoinsDtoList': this.protocolCoinsDtoList,
          'protocolRiskDtoList': this.protocolRiskDtoList
        };
        console.log(para);

        _submitProtoInfo(para).then(function (res) {
          console.log(res);

          if (res.rtnCode === '0000') {
            if (type === '0') {
              // 暂存成功后还可以继续进行操作
              _this33.loading = false;

              _this33.$message({
                type: 'success',
                message: res.rtnMsg
              });
            } else {
              // 保存成功后，跳转到列表页面
              _this33.$message({
                type: 'success',
                message: res.rtnMsg
              }); // this.$router.push({
              //   name: 'protocoSearch'
              // })


              _this33.$router.go(-1);
            }
          } else {
            console.log(res.rtnMsg);

            _this33.$message.error('保存失败，请联系管理员。');

            _this33.loading = false;
          }
        }).catch(function (err) {
          console.log(err.message); // this.$message.error('保存失败，请联系管理员。')

          _this33.loading = false;
        });
      }
    },
    //显示隐藏的标的
    setTagTitle: function setTagTitle() {
      var tagTextList = document.querySelector('#app').querySelectorAll('.el-select__tags-text');
      tagTextList.forEach(function (item) {
        item.setAttribute('title', item.innerText);
      });
    },

    /**
     * 动态必填验证逻辑
     */
    internalPushEmailValidator: function internalPushEmailValidator(rule, value, callback) {
      if (this.isRequired && !value) {
        callback(new Error('邮件发送对象勾选了内部推送邮箱时，内部推送邮箱必填'));
      } else {
        // 验证通过
        callback();
      }
    },

    /**
     * 内部推送邮箱添加必填
     */
    addRequired: function addRequired(rule, value, callback) {
      var flag = false;

      if (value) {
        for (var i = 0; i < value.length; i++) {
          if (value[i] == "4") {
            flag = true;
          }
        }

        this.isRequired = flag;
        callback();
      } else {
        callback();
      }
    }
    /**
             * 影像上传
             */
    // imageProtoUpload() {
    //
    // }

  } // watch: {
  //   $route (to, from) {
  //     this.$router.go(0);
  //   }}

};